import { Checkbox, Divider, Dropdown, Popover, Select, Spin, Tooltip } from 'antd';
import InputField from '../../components/InputField';
import { useForm } from 'react-hook-form';
import AnimatedSVG from '../../components/Loader';
import { Button } from '../../components/Buttons';
import {
    AlertIcon,
    BookmarkIcon,
    BrandGAds,
    BrandGAnalytics,
    BrandMagento,
    YoutubeLogo,
    BrandMeta,
    BrandShopify,
    CloseIcon,
    CollapseIcon,
    CustomIntegrationLogo,
    DeleteRedIcon,
    DisLikeButtonActiveIcon,
    DownloadIcon,
    EditChatIcon,
    LikeButtonActiveIcon,
    OogwaiLogo3,
    PinChatIcon,
    PlusIcon,
    RegenerateChatIcon,
    RightArrowIcon,
    ThumbsDownIcon,
    ThumbsUpIcon,
    GreenRight,
    ChevronRightIcon
} from "../../components/Icons/iconImages";
import "./conversation.css";
import { Modal } from '../../components/Modal';
import useModal from '../../Hooks/useModal';
import IconRings from '../../components/IconRings';
import ToggleButton from '../../components/Toggle';
import { PillsBadge } from '../../components/Badge';
import {
    useAutoSuggestionMutation,
    useBookMarkConversationMutation,
    useDeleteBookMarkInConversationMutation,
    useDeleteChatHistoryMutation,
    // useGetDefaultPropertiesConversationQuery - removed, using localStorage
    useLazyAskGoogleAnalyticsQuestionQuery,
    useLazyEditQuestionQuery,
    useLazyGetChatHistoryQuery,
    useLazyGetConversationHistoryQuery,
    useLazyGetDashboardNamesQuery,
    useLazySendFeedBackQuestionQuery,
    useRemoveBookmarkMutation,
    // useSaveDefaultPropertiesConversationMutation - removed, using localStorage
    useThumbsUpStatusMutation,
    useUpdateChatNameMutation,
    useUpdateCommentsMutation,
    useUpdateHistoryOrNotMutation,
    useCreateDashboardMutation,
} from '../../services/dashboardSlice';
import {
    useExportConversationTableQuery,
    useGetAnalyticStatusQuery,
    useGetCustomBigQueryConversationDropdownQuery,
    useGetDataSourceListQuery,
    useGetQuestionQueryStatusQuery
} from "../../services/integrationSlice";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TableData, DynamicTable } from '../../components/Table';

// import conversationData from '../../constants/chat-history.json'; // ! DUMMY
import CustomChart from '../../components/ChartComponents/BarChart';
import { CustomGeoMap } from '../../components/ui/custom-chart';
import { useDebounce } from '../../Hooks/useDebounceHook';
import useIsInIframe from '../../Hooks/useIsInIframe';
import AskAILogo from '../../components/Icons/AskAILogo';
import gsap from "gsap";
import PromptSuggestions from '../../components/PromptSuggestions';
import { validationConstants } from '../../constants/validations';
import { Modal as AntdModal } from 'antd';
import { ExpandIcon } from "../../components/Icons/iconImages";
import { useDispatch, useSelector } from 'react-redux';
import { createDashboardName, isPropertyIdClear, updateNewConversation } from '../../services/staticSlice';
import ReactGA from "react-ga4";
import { toast } from '../../components/Toast/toast';
import { Input } from 'antd';
import useNetworkStatus from '../../Hooks/useNetworkStatus';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import { useOnboardingTour } from '../../Hooks/useOnboardingTour';
import { getTour } from '../../components/OnboardingTour/tourConfigs';
import OnboardingTour from '../../components/OnboardingTour/SafeOnboardingTour';
import { useSSEStream } from '../../Hooks/useSSEStream';
import { buildSSEUrl, getWorkspaceId as getWorkspaceIdFromStorage, getAuthToken } from '../../utils/sseHelper';
import StreamingText from '../../components/StreamingText';
import { baseApi } from '../../services/baseQuery';

const { TextArea } = Input;
const { Option } = Select;

const ErrorComponent = ({ onClose, onTryNewQuery }) => {
    const containerRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] ErrorComponent mount animation');
        if (containerRef.current) {
            gsap.from(containerRef.current, {
                delay: 0.5,
                duration: 0.2,
                opacity: 0,
                y: -20,
                ease: 'power2.out'
            });
        }
    }, []);

    const handleClose = useCallback(() => {
        if (containerRef.current) {
            gsap.to(containerRef.current, {
                duration: 0.1,
                opacity: 0,
                y: -20,
                ease: 'power2.in',
                onComplete: () => onClose()
            });
        }
    }, [onClose]);

    const handleTryNewQuery = () => {
        handleClose();
        // Clear the chat ID from URL
        navigate('/conversation', { replace: true });
        // Call the parent's handler to reset chat state
        if (onTryNewQuery) {
            onTryNewQuery();
        }
        // Focus on input
        const inputElement = document.getElementById('inputquestionInput');
        if (inputElement) {
            inputElement.focus();
        }
    };

    return (
        <div
            ref={containerRef}
            className="m-3 flex items-start justify-between gap-1 bg-[#FEF3F2] border border-[#FDA29B] rounded-2xl"
        >
            <div className="flex gap-1 items-start">
                <IconRings
                    borderWidth={2}
                    ringColor={'#d92c2037'}
                    numRings={3}
                    ringBaseSize={20}
                    ringSpacing={10}
                    className=""
                >
                    <AlertIcon className="w-5 h-5 text-red-500" />
                </IconRings>
                <div className="my-3">
                    <h5>Sorry, we can’t find what you are looking for</h5>
                    <p className="text-sm">
                        We are working on adding new data points everyday. Please try asking for something else
                    </p>
                    <div className="flex items-center gap-2">
                        <Button
                            className="p-0 text-gray-900"
                            type="text"
                            color="default"
                            onClick={() => {
                                handleClose();
                                handleTryNewQuery();
                            }}
                        >
                            Try a new query
                        </Button>
                        <Button
                            className="p-0"
                            variant="text"
                            color={"primary"}>
                            Learn more
                        </Button>
                    </div>
                </div>
            </div>
            <div className="pt-2 pr-2">
                <Button
                    shape="circle"
                    type="text"
                    icon={<CloseIcon className="w-3 h-3 text-gray-800" />}
                    onClick={handleClose}
                />
            </div>
        </div>
    );
};

const integrationIcons = {
    GA4: <BrandGAnalytics className="h-[30px] w-[30px]" />,
    Shopify: <BrandShopify className="h-[30px] w-[30px]" />,
    Meta: <BrandMeta className="h-[30px] w-[30px]" />,
    GoogleAds: <BrandGAds className="h-[30px] w-[30px]" />,
    Magento: <BrandMagento className="h-[30px] w-[30px]" />,
    Custom: <CustomIntegrationLogo className="h-[30px] w-[30px]" />,
    YouTube: <YoutubeLogo className="h-[30px] w-[30px]" />,
    YouTubeChannel: <YoutubeLogo className="h-[30px] w-[30px]" />
    // Add more mappings as needed
};

const agentIconsSmall = {
    GA4: <BrandGAnalytics className="h-[20px] w-[20px]" />,
    Shopify: <BrandShopify className="h-[20px] w-[20px]" />,
    Meta: <BrandMeta className="h-[20px] w-[20px]" />,
    GoogleAds: <BrandGAds className="h-[20px] w-[20px]" />,
    Magento: <BrandMagento className="h-[20px] w-[20px]" />,
    Custom: <CustomIntegrationLogo className="h-[20px] w-[20px]" />,
    YouTube: <YoutubeLogo className="h-[20px] w-[20px]" />,
    YouTubeChannel: <YoutubeLogo className="h-[20px] w-[20px]" />
    // Add more mappings as needed
};

const IntegrationPropertySelector = ({
    newChat = true,
    listIntegrationData,
    selectedIds,
    setSelectedIds,
    handleSaveDefaultProperties,
    setSearchQuery,
    listAnalyticsLoading = false,
    customBigQueryConversationDropdownLoading = false,
    conversationPropertyIds = null // New prop for conversation-specific IDs
}) => {

    const [open, setOpen] = useState(false);
    const [tempSelection, setTempSelection] = useState(selectedIds || []);
    const [searchImmediate, setSearchImmediate] = useState("");
    const dataSourceScrollRef = useRef(null);
    const [search, setSearch] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] IntegrationPropertySelector search changed', { search });
        setSearchQuery(search)
    }, [search])

    // Prevent data source dropdown scroll from propagating to main content
    useEffect(() => {
        const scrollElement = dataSourceScrollRef.current;

        const handleWheel = (e) => {
            const { scrollTop, scrollHeight, clientHeight } = scrollElement;
            const isAtTop = scrollTop === 0;
            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

            // Prevent scroll propagation when at boundaries and trying to scroll further
            if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        if (scrollElement) {
            scrollElement.addEventListener('wheel', handleWheel, { passive: false });
        }

        return () => {
            if (scrollElement) {
                scrollElement.removeEventListener('wheel', handleWheel);
            }
        };
    }, []);

    const navigate = useNavigate();

    // useEffect(() => {
    //     if (open) {
    //         setTempSelection(selectedIds || []);
    //     }
    // }, [open, selectedIds]);

    const handleCheckboxChange = (value, checked) => {
        const updated = checked
            ? [...tempSelection, value]
            : tempSelection.filter((id) => id !== value);

        setTempSelection(updated);
        setSelectedIds(updated);

        // Always save to storage when checkbox changes, regardless of new chat or existing chat
        // Filter out "Not Integrated" items (isTextOnly) from being sent to the API
        handleSaveDefaultProperties({
            customPropertyId: updated.filter((id) => {
                const item = groupedProperties.Custom.find((item) => item.propertyId === id);
                return item && !item.isTextOnly;
            }),
            gaPropertyId: updated.filter((id) => {
                const item = groupedProperties.GA4.find((item) => item.propertyId === id);
                return item && !item.isTextOnly;
            }),
            shopifyPropertyId: updated.filter((id) => {
                const item = groupedProperties.Shopify.find((item) => item.propertyId === id);
                return item && !item.isTextOnly;
            }),
            metaPropertyId: updated.filter((id) => {
                const item = groupedProperties.Meta.find((item) => item.propertyId === id);
                return item && !item.isTextOnly;
            }),
            adsPropertyId: updated.filter((id) => {
                const item = groupedProperties.GoogleAds.find((item) => item.propertyId === id);
                return item && !item.isTextOnly;
            }),
        });
    };

    // Build grouped properties including conversation IDs that might not be integrated
    const buildGroupedProperties = () => {
        const integrated = {
            GA4: listIntegrationData?.property_names?.filter(p => p.integrationType === "GA4") || [],
            Shopify: listIntegrationData?.property_names?.filter(p => p.integrationType === "Shopify") || [],
            Meta: listIntegrationData?.property_names?.filter(p => p.integrationType === "Meta") || [],
            GoogleAds: listIntegrationData?.property_names?.filter(p => p.integrationType === "GoogleAds") || [],
            Custom: listIntegrationData?.property_names?.filter(p => p.integrationType === "Custom") || [],
            YouTube: listIntegrationData?.property_names?.filter(p => p.integrationType === "YouTube") || [],
            // Support multiple possible spellings for channel type
            YouTubeChannel: listIntegrationData?.property_names?.filter(p => ["YouTubeChannel", "YouTubeChannels", "YoutubeChannel"].includes(p.integrationType)) || [],
        };

        // If we have conversation property IDs, add any that aren't already in the integrated list
        if (conversationPropertyIds) {
            const { gaIds = [], shopifyIds = [], metaIds = [], adsIds = [], customIds = [], youtubeIds = [], youtubeChannelIds = [] } = conversationPropertyIds;

            // Helper to add missing IDs
            const addMissingIds = (type, ids, integratedList) => {
                // Ensure ids is always an array
                const idsArray = Array.isArray(ids) ? ids : (ids ? [ids] : []);
                const validIds = idsArray.filter(id => id && id !== ''); // Filter out empty strings

                const existingIds = integratedList.map(item => item.propertyId);
                const missingIds = validIds.filter(id => !existingIds.includes(id));

                return [
                    ...integratedList,
                    ...missingIds.map(id => ({
                        propertyId: id,
                        propertyName: `${id} (Not Integrated)`,
                        integrationType: type,
                        isFromConversation: true,
                        disabled: true,
                        isTextOnly: true // Display as text, not checkbox
                    }))
                ];
            };

            return {
                GA4: addMissingIds("GA4", gaIds, integrated.GA4),
                Shopify: addMissingIds("Shopify", shopifyIds, integrated.Shopify),
                Meta: addMissingIds("Meta", metaIds, integrated.Meta),
                GoogleAds: addMissingIds("GoogleAds", adsIds, integrated.GoogleAds),
                Custom: addMissingIds("Custom", customIds, integrated.Custom),
                YouTube: addMissingIds("YouTube", youtubeIds, integrated.YouTube),
                YouTubeChannel: addMissingIds("YouTubeChannel", youtubeChannelIds, integrated.YouTubeChannel),
            };
        }

        return integrated;
    };

    const groupedProperties = buildGroupedProperties();

    const integrationTitle = (type) => {
        switch (type) {
            case "GA4": return "Google Analytics";
            case "Shopify": return "Shopify";
            case "Meta": return "Meta Analytics";
            case "GoogleAds": return "Google Ads";
            case "Custom": return "Custom BigQuery";
            case "YouTube": return "YouTube";
            case "YouTubeChannel": return "YouTube Channels";
            default: return type;
        }
    };

    const selectedByType = {
        GA4: groupedProperties.GA4.filter((item) => selectedIds.includes(item.propertyId)),
        Shopify: groupedProperties.Shopify.filter((item) => selectedIds.includes(item.propertyId)),
        Meta: groupedProperties.Meta.filter((item) => selectedIds.includes(item.propertyId)),
        GoogleAds: groupedProperties.GoogleAds.filter((item) => selectedIds.includes(item.propertyId)),
        Custom: groupedProperties.Custom.filter((item) => selectedIds.includes(item.propertyId)),
        YouTube: (groupedProperties.YouTube || []).filter((item) => selectedIds.includes(item.propertyId)),
        YouTubeChannel: (groupedProperties.YouTubeChannel || []).filter((item) => selectedIds.includes(item.propertyId)),
    };

    const selectedTypes = Object.entries(selectedByType).filter(([_, items]) => items.length > 0);

    const selectedIconPreview = (
        <div className="flex items-center gap-2">
            <span className="text-xs md:text-sm font-medium">Data Sources:</span>
            {listAnalyticsLoading || customBigQueryConversationDropdownLoading ? (
                <div className="flex items-center gap-2">
                    <Spin size="small" />
                    <span className="text-xs text-gray-500">Loading...</span>
                </div>
            ) : selectedTypes.length > 0 && (
                <div className="relative flex -space-x-2 md:-space-x-3">
                    {selectedTypes.map(([type, items], index) => {
                        // Check if all items in this type are "Not Integrated"
                        const hasNotIntegrated = items.some(item => item.propertyName?.includes('(Not Integrated)'));
                        const allNotIntegrated = items.every(item => item.propertyName?.includes('(Not Integrated)'));

                        return (
                            <div key={type} className="relative cursor-pointer">
                                <div
                                    className={`w-7 h-7 md:w-9 md:h-9 bg-white rounded-full border flex items-center justify-center shadow-sm ${allNotIntegrated ? 'border-gray-400' : 'border-green-600'
                                        }`}
                                    style={{ zIndex: 10 - index }}
                                >
                                    <div className={`w-6 h-6 md:w-8 md:h-8 flex items-center justify-center ${allNotIntegrated ? 'opacity-50 grayscale' : ''}`}>
                                        {React.cloneElement(integrationIcons[type], {
                                            className: "w-5 h-5 md:w-7 md:h-7" // responsive icon size
                                        })}
                                    </div>
                                </div>

                                {/* Count badge */}
                                <div className={`absolute -bottom-4 md:-bottom-5 left-1/2 -translate-x-1/2 text-[9px] md:text-[10px] rounded-full w-3.5 h-3.5 md:w-4 md:h-4 flex items-center justify-center border ${allNotIntegrated
                                        ? 'bg-gray-200 text-gray-500 border-gray-300'
                                        : 'bg-gray-200 text-gray-800 border-gray-300'
                                    }`}>
                                    {items.length}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );

    const isEmpty = Object.values(groupedProperties).every(arr => arr.length === 0);

    const _onChangeDebounced = async (text) => {
        setSearch(text)
    };

    const onChangeDebounced = useDebounce(_onChangeDebounced);

    const content = (
        <div className="w-[90vw] md:min-w-[400px] max-w-screen-sm rounded-xl border border-gray-200 bg-white shadow-md flex flex-col max-h-[70vh] md:max-h-[500px]">
            <div className='p-3 border-b sticky top-0 bg-white z-10'>
                <Input
                    placeholder="Search Data Source"
                    className='h-11 rounded-md'
                    value={searchImmediate}
                    onChange={(e) => {
                        onChangeDebounced(e.target.value);
                        setSearchImmediate(e.target.value)
                    }}
                    allowClear
                />
            </div>
            <div className="overflow-x-auto overflow-y-auto flex-1" ref={dataSourceScrollRef}>
                {listAnalyticsLoading || customBigQueryConversationDropdownLoading ? (
                    <div className="w-full p-6 flex flex-col items-center justify-center">
                        <Spin size="large" />
                        <p className="mt-4 text-gray-600 text-sm">Loading data sources...</p>
                    </div>
                ) : isEmpty ? (
                    <div className="w-full p-4 md:p-6 flex flex-col gap-2 justify-start items-start">
                        <div className="w-8 h-8 rounded-full border bg-green-50 flex items-center justify-center">
                            <AlertIcon className="text-green-500 text-lg" />
                        </div>
                        <h4 className="font-semibold text-sm md:text-base">No Data Source added</h4>
                        <p className="text-xs md:text-sm">Please start by integrating a data source.</p>
                        <p className="text-xs md:text-sm">
                            In just 2 minutes, connect your data to Oogwai and start having real-time conversations that transform complexity into clarity.
                            Because when your data talks, you take charge.
                        </p>
                        <Button
                            type="primary"
                            icon={<PlusIcon />}
                            onClick={() => navigate("/integrations")}
                            size="small"
                        >
                            Connect Now
                        </Button>
                    </div>
                ) : (
                    <div className="w-full divide-y md:divide-y-0 md:divide-x-2">
                        <div className='flex flex-col md:flex-row'>
                            {Object.entries(groupedProperties)
                                .filter(([_, items]) => items?.length > 0)
                                .map(([type, items]) => (
                                    <div key={type} className="bg-white w-full md:min-w-[335px] py-1.5">
                                        <div className="flex pl-2 items-center gap-2 font-semibold text-xs md:text-sm pb-2">
                                            {integrationIcons[type] || integrationIcons["Custom"]}
                                            <span>{integrationTitle(type)}</span>
                                        </div>

                                        <div className="flex gap-1 flex-col mx-1.5 bg-gray-50 p-1 rounded-lg mr-1.5 md:mr-3">
                                            {items.map((item, index) => (
                                                item.isTextOnly ? (
                                                    <div
                                                        key={`${item.integrationType}-${item.propertyId}-${index}`}
                                                        className="flex items-center gap-2 rounded-lg cursor-default opacity-60 bg-white p-2 md:p-3"
                                                    >
                                                        <span className="truncate text-xs md:text-sm text-gray-500 italic">
                                                            {item.propertyName && item.integrationType !== "Custom" ? `${item.propertyName} - ${item.propertyId}` : item.propertyId}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <label
                                                        key={`${item.integrationType}-${item.propertyId}-${index}`}
                                                        className={`flex items-center gap-2 rounded-lg ${item.disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} bg-white p-2 md:p-3`}
                                                    >
                                                        <Checkbox
                                                            checked={tempSelection.includes(item.propertyId)}
                                                            disabled={item.disabled}
                                                            onChange={(e) => {
                                                                if (item.disabled) return;
                                                                if (item.integrationType === "Custom" && selectedIds.filter(id => id !== item.propertyId).some(id => groupedProperties.Custom.find(property => property.propertyId === id))) {
                                                                    toast.warn('Cannot select multiple custom properties');
                                                                    return;
                                                                }
                                                                handleCheckboxChange(item.propertyId, e.target.checked)
                                                            }
                                                            }
                                                        />
                                                        <span className={`truncate text-xs md:text-sm ${item.disabled ? 'text-gray-500' : ''}`}>
                                                            {item.propertyName && item.integrationType !== "Custom" ? `${item.propertyName} - ${item.propertyId}` : item.propertyId}
                                                        </span>
                                                    </label>
                                                )
                                            ))}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <Popover
            content={content}
            arrow={false}
            trigger="click"
            open={open}
            overlayInnerStyle={{ padding: 0, boxShadow: 'none' }}
            onOpenChange={setOpen}
            onClick={() => setTempSelection(selectedIds || [])}
            placement={isMobile ? "bottom" : "bottomRight"}
        >
            <div className="flex items-center gap-1 pb-3.5">
                {selectedIconPreview}
                <Button
                    size="small"
                    shape="circle"
                    type="dashed"
                    icon={
                        <>
                            <PlusIcon className="hidden md:block w-3 h-3 text-gray-500" />
                            <ChevronRightIcon className="rotate-90 md:hidden w-3 h-3 text-gray-500" />
                        </>
                    }
                    className="bg-white border-gray-300 text-gray-700 hover:border-blue-500 hover:text-blue-600 shadow-sm ml-1"
                />
            </div>
        </Popover>
    );
};


const Conversation = () => {
    const didMount = useRef(false);
    const preferencesLoadedRef = useRef(false);

    // Detect if running in iframe
    const isInIframe = useIsInIframe();

    useEffect(() => {
        console.log('🖼️ iframe detection:', isInIframe ? 'Running in iframe' : 'Running standalone');
    }, [isInIframe]);

    // Onboarding tour for conversation
    const conversationTourData = getTour('conversation');
    const {
        runTour,
        currentTour,
        closeTour,
        skipTour,
        resetTours,
        startTour
    } = useOnboardingTour(conversationTourData, {
        delay: 2000, // Show tour after 2 seconds
        autoStart: false, // Don't auto-start, only start manually from tour helper
        chainToNext: true // Enable tour chaining to continue sequence
    });

    // Listen for manual tour start events
    useEffect(() => {
        const handleStartTour = (event) => {
            const tourData = event.detail;
            // Only start this tour if it matches the conversation tour and no tour is currently running
            if (tourData && tourData.id === 'conversation-tour' && !runTour) {
                startTour(tourData, tourData.isChainedTour || false);
            }
        };

        window.addEventListener('startTour', handleStartTour);
        return () => {
            window.removeEventListener('startTour', handleStartTour);
        };
    }, [startTour, runTour]);
    const [data, setData] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const getWorkspaceId = useSelector((state) => state?.static?.workSpaceId);
    const isClearPropertyId = useSelector((state) => state?.static?.isPropertyIdClear);
    const newConversation = useSelector((state) => state?.static?.newConversation);
    const dispatch = useDispatch();

    const [gaPropertyId, setGaPropertyId] = useState([]);
    const [shopifyPropertyId, setShopifyPropertyId] = useState([]);
    const [metaPropertyId, setMetaPropertyId] = useState([]);
    const [adsPropertyId, setAdsPropertyId] = useState([]);
    const [customPropertyId, setCustomPropertyId] = useState([]);
    const [youtubePropertyId, setYoutubePropertyId] = useState([]);
    const [youtubeChannelId, setYoutubeChannelId] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [userModifiedDataSources, setUserModifiedDataSources] = useState(false);
    const conversationDataLoadedRef = useRef(false);
    const chatIdFromStreamingRef = useRef(false); // Track if chatId came from streaming (to avoid redundant API call)
    const lastLoadedChatIdRef = useRef(null); // Track which chatId we last loaded history for
    const pendingChatIdRef = useRef(null); // Track which chatId we're currently loading from API
    const isOnline = useNetworkStatus();
    const { getCurrentWorkspaceObjectId } = useWorkspace();
    // Compute current workspace ObjectId each render for dependency tracking
    const workspaceObjectId = getCurrentWorkspaceObjectId();

    // Clear search query when workspace changes
    useEffect(() => {
        setSearchQuery("");
    }, [workspaceObjectId]);

    const { data: listAnalyticsData, isLoading: listAnalyticsLoading, isFetching: listAnalyticsFetching, isSuccess: listAnalyticsSuccess, refetch: refetchPropertyId } = useGetDataSourceListQuery(searchQuery, {
        // skip: !getStatus?.googleanalytics,
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true
    });

    const { data: listCustomBigQueryData, isLoading: customBigQueryConversationDropdownLoading, isFetching: customBigQueryFetching, isSuccess: customBigQueryConversationDropdownSuccess } = useGetCustomBigQueryConversationDropdownQuery(workspaceObjectId, {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
        refetchOnReconnect: true
    })

    // localStorage-based account selection utilities
    const getSelectedAccountsFromStorage = () => {
        const workspaceId = getCurrentWorkspaceObjectId();
        const storageKey = `selected-accounts-${workspaceId}`;
        try {
            const stored = localStorage.getItem(storageKey);
            return stored ? JSON.parse(stored) : null;
        } catch (error) {
            console.warn('Failed to parse stored account selection:', error);
            return null;
        }
    };

    const saveSelectedAccountsToStorage = (accountData) => {
        const workspaceId = getCurrentWorkspaceObjectId();
        const storageKey = `selected-accounts-${workspaceId}`;
        try {
            localStorage.setItem(storageKey, JSON.stringify(accountData));
        } catch (error) {
            console.warn('Failed to save account selection to localStorage:', error);
        }
    };

    // Simulate the API data structure for backward compatibility
    const defaultPropertiesData = getSelectedAccountsFromStorage();
    const defaultPropertiesLoading = false; // localStorage is synchronous


    // Show guidance toast only when both loaders are done and there are no analytics properties
    // Avoid referencing listIntegrationData here because it's defined later
    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] Guidance toast check', {
            listAnalyticsLoading,
            listAnalyticsFetching,
            customBigQueryConversationDropdownLoading,
            customBigQueryFetching,
            analyticsCount: listAnalyticsData?.property_names?.length ?? 0,
            customBqCount: listCustomBigQueryData?.dataset_id ? 1 : 0
        });

        // Skip if either query is still loading or fetching (during workspace switch)
        if (listAnalyticsLoading || listAnalyticsFetching || customBigQueryConversationDropdownLoading || customBigQueryFetching) {
            return;
        }

        // Only show toast after both queries are successful and data has stabilized
        if (listAnalyticsSuccess && customBigQueryConversationDropdownSuccess) {
            // Add a small delay to ensure data has fully settled after workspace switch
            const timeoutId = setTimeout(() => {
                const analyticsCount = listAnalyticsData?.property_names?.length ?? 0;
                const customBqCount = listCustomBigQueryData?.dataset_id ? 1 : 0;
                const totalCount = analyticsCount + customBqCount;
                if (totalCount === 0) {
                    toast.warning("Please select the data source", { toastId: 'select-property' });
                }
            }, 500); // 500ms delay to avoid showing during rapid state changes

            return () => clearTimeout(timeoutId);
        }
    }, [
        listAnalyticsLoading,
        listAnalyticsFetching,
        customBigQueryConversationDropdownLoading,
        customBigQueryFetching,
        listAnalyticsSuccess,
        customBigQueryConversationDropdownSuccess,
        listAnalyticsData?.property_names?.length,
        listCustomBigQueryData?.dataset_id
    ])

    const [getDashboardNames, { data: dashboardNamesData }] = useLazyGetDashboardNamesQuery()
    // Avoid logging on every render; log only when data actually changes
    const prevDashboardNamesRef = useRef(null);
    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] dashboardNamesData changed');
        // In dev, StrictMode may double-invoke; guard with ref to avoid duplicate logs
        if (dashboardNamesData && prevDashboardNamesRef.current !== dashboardNamesData) {
            if (process.env.NODE_ENV !== 'production') {
                // Use debug-level log to make it easy to filter in dev tools
                // eslint-disable-next-line no-console
                console.debug('dashboardNamesData', dashboardNamesData);
            }
            prevDashboardNamesRef.current = dashboardNamesData;
        }
    }, [dashboardNamesData]);

    // Clear conversation data when workspace changes
    useEffect(() => {
        setData([]);
        setChatId("");
        chatIdFromStreamingRef.current = false;
        lastLoadedChatIdRef.current = null;
        pendingChatIdRef.current = null;
    }, [getWorkspaceId]);

    const [getConversation, { data: getConversationData, isLoading: getConversationLoading }] = useLazyGetConversationHistoryQuery()
    const [chatId, setChatId] = useState("");
    const [search, setSearch] = useState("");
    const _onChangeDebounced = async (text) => {
        // Count only alphabetic characters (a-z, A-Z)
        const alphabetCount = (text.match(/[a-zA-Z]/g) || []).length;
        if (alphabetCount >= 3) {
            setSearch(text);
        } else {
            // Clear search and suggestions if less than 3 alphabets
            setSearch("");
            setSuggestions([]);
        }
    };
    const [deleteChatId, setDeleteChatId] = useState("");
    const [bookmarked, setBookmarked] = useState(false);
    const onChangeDebounced = useDebounce(_onChangeDebounced, 500);

    const [getSuggestion, { isLoading: suggestionLoading, isSuccess: suggestionSuccess, data: suggestionData, isError: suggestionError }] = useAutoSuggestionMutation();
    const [suggestions, setSuggestions] = useState([])
    const [suggestionPayload, setSuggestionPayload] = useState(null);
    const [thumbsUpStatus, { isLoading: thumbsUpLoading }] = useThumbsUpStatusMutation();
    const [updateComments] = useUpdateCommentsMutation();

    const [isOpenVisualModal, setOpenVisualModal] = useState({
        state: false,
        type: null,
        response: {}
    });
    const [exportEnable, setExportEnable] = useState(true);

    const exportTablePayload = React.useMemo(() => ({
        chat_id: chatId,
        timestamp: isOpenVisualModal?.response?.timestamp,
    }), [chatId, isOpenVisualModal])

    const { data: exportRes } = useExportConversationTableQuery(exportTablePayload, {
        skip: exportEnable
    })

    const [getChatHistory, { data: chatData, isLoading: isChatHistoryLoading, isError: isChatHistoryError }] = useLazyGetChatHistoryQuery()


    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] exportRes changed');
        if (
            exportRes?.status !== "uninitialized" &&
            exportRes?.status !== "pending"
        ) {
            if (exportRes) {
                var hiddenElement = document.createElement('a');
                var url = window.URL || window.webkitURL;
                var blobPDF = url.createObjectURL(exportRes);
                hiddenElement.href = blobPDF;
                hiddenElement.target = '_blank';
                hiddenElement.download = `${chatId}-${isOpenVisualModal?.response?.timestamp}.xlsx`;
                hiddenElement.click();
                setExportEnable(true);
            } else {
                setExportEnable(true);
            }
        }
    }, [exportRes]);

    // Effect for fetching suggestions
    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] search changed', { search });
        if (search) {
            const payload = {
                "user_input": search,
                "workspace_id": getCurrentWorkspaceObjectId()
            }
            setSuggestionPayload(payload);
            getSuggestion(payload);
        }
    }, [search])


    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] suggestion results changed', { suggestionSuccess, hasData: !!suggestionData, hasPayload: !!suggestionPayload, suggestionError });
        if (suggestionSuccess && suggestionData && suggestionPayload) {
            if (suggestionData?.suggestions && suggestionPayload?.user_input?.length > 0) {
                // setSuggestions((prev) => {
                //     const existing = new Set(prev.map((item) => item.suggestion));
                //     const newSuggestions = suggestionData.suggestions.filter(
                //         (item) => !existing.has(item.suggestion)
                //     );
                //     return [...prev, ...newSuggestions];
                // });
                setSuggestions(suggestionData.suggestions);
            }
            setSuggestionPayload(null);
        }
        if (suggestionError && suggestionPayload) {
            setSuggestionPayload(null);
        }
    }, [suggestionSuccess, suggestionData, suggestionError, suggestionPayload]);

    // Fetch dashboard names when component mounts or workspace changes
    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] fetch dashboard names for workspace:', workspaceObjectId);
        getDashboardNames().unwrap().catch(() => { /* no-op */ });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workspaceObjectId])

    // Update form value when dashboard names data changes
    useEffect(() => {
        if (dashboardNamesData?.dashboard_names?.length > 0) {
            // Reset the dashboard_name field to the first available dashboard
            setValue('dashboard_name', dashboardNamesData.dashboard_names[0], { shouldValidate: false });
            // eslint-disable-next-line no-console
            console.log('[Effect] Updated dashboard_name to:', dashboardNamesData.dashboard_names[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dashboardNamesData])

    // Reset preferences when switching from a chat to new chat
    useEffect(() => {
        // Check if we're switching from a chat (had chatId) to new chat (no chatId)
        if (chatId === "" && location.pathname === "/conversation") {
            // Reset the preferences loaded flag to allow reloading saved values
            preferencesLoadedRef.current = false;
            // Clear suggestions when opening Ask Oogwai without a specific chat
            setSuggestions([]);
        }
    }, [chatId, location.pathname])

    // Moved to after getmenuInfo definition

    const suggestionRef = useRef(null);
    const suggestionsRef = useRef(null);

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] suggestionLoading changed', { suggestionLoading });
        if (suggestionLoading) {
            gsap.fromTo(
                suggestionRef.current,
                { height: 0, opacity: 0 },
                { height: "auto", opacity: 1, duration: 0.5, ease: "power2.out" }
            );
        } else {
            gsap.to(suggestionRef.current, { height: 0, opacity: 0, duration: 0.3, ease: "power2.in" });
        }
    }, [suggestionLoading]);

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] suggestions changed', { count: suggestions?.length });
        if (suggestions?.length > 0) {
            gsap.fromTo(
                suggestionsRef.current,
                { height: 0, opacity: 0 },
                { height: "auto", opacity: 1, duration: 0.5, ease: "power2.out" }
            );
        } else if (suggestionsRef.current) {
            gsap.to(suggestionsRef.current, { height: 0, opacity: 0, duration: 0.3, ease: "power2.in" });
        }
    }, [suggestions]);


    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] workspace changed', { getWorkspaceId });
        getConversation()
        refetchPropertyId();
    }, [getWorkspaceId])

    // Monitor shadow user changes for impersonation
    const [shadowUser, setShadowUser] = useState(() => localStorage.getItem('oogw.ai_shadow_user_email'));

    useEffect(() => {
        const handleStorageChange = () => {
            const newShadowUser = localStorage.getItem('oogw.ai_shadow_user_email');
            if (newShadowUser !== shadowUser) {
                // eslint-disable-next-line no-console
                console.log('[Effect] shadow user changed, refreshing conversations', {
                    oldShadowUser: shadowUser,
                    newShadowUser
                });
                setShadowUser(newShadowUser);
                // Small delay to ensure API state is reset
                setTimeout(() => {
                    getConversation();
                }, 100);
            }
        };

        // Check on mount and when focus returns to window
        handleStorageChange();
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('focus', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('focus', handleStorageChange);
        };
    }, [shadowUser, getConversation])


    // Track if we're in the middle of loading a specific chat
    const isLoadingChatRef = useRef(false);

    useEffect(() => {
        // Check if we're trying to load a specific chat from URL
        const urlParams = new URLSearchParams(location.search);
        const chatIdFromUrl = urlParams.get('chatid');

        if (chatIdFromUrl) {
            isLoadingChatRef.current = true;
            console.log('[Effect] Detected chatId in URL, setting loading flag:', chatIdFromUrl);
        } else if (!chatIdFromUrl && isLoadingChatRef.current) {
            // Reset flag if we navigate away from a chat
            isLoadingChatRef.current = false;
            console.log('[Effect] No chatId in URL, clearing loading flag');
        }
    }, [location.search]);

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] newConversation changed', { newConversation });
        console.log('[Effect] newConversation - current chatId state:', chatId);
        console.log('[Effect] newConversation - location.search:', location.search);
        console.log('[Effect] newConversation - isLoadingChatRef.current:', isLoadingChatRef.current);

        // Check sessionStorage flag
        const isLoadingSpecificChat = sessionStorage.getItem('isLoadingSpecificChat') === 'true';
        console.log('[Effect] newConversation - sessionStorage isLoadingSpecificChat:', isLoadingSpecificChat);

        // Check if there's a chatId in the URL
        const urlParams = new URLSearchParams(location.search);
        const chatIdFromUrl = urlParams.get('chatid');
        console.log('[Effect] newConversation - chatIdFromUrl:', chatIdFromUrl);

        if (newConversation) {
            // Only skip clearing if we're actively loading a specific chat from URL
            const shouldSkipClear = (chatIdFromUrl && (isLoadingChatRef.current || isLoadingSpecificChat));

            if (!shouldSkipClear) {
                console.log('[Effect] newConversation - clearing conversation for new chat');
                setData([])
                setValue("questionInput", '');
                setSuggestions([]); // Clear suggestions when opening Ask Oogwai

                // Always navigate to clean conversation URL without chatId
                navigate("/conversation", { replace: true })
                getConversation();
                setChatId("")
                setUseHistoryToggle(true)
                setHistory(true);

                // Reset preferences loaded flag to allow reloading default values
                preferencesLoadedRef.current = false;

                // Reset data source modification flags
                setUserModifiedDataSources(false);
                conversationDataLoadedRef.current = false;
                chatIdFromStreamingRef.current = false;
                lastLoadedChatIdRef.current = null;
                pendingChatIdRef.current = null;

                // Reset the newConversation flag after clearing is done
                setTimeout(() => {
                    dispatch(updateNewConversation(false))
                }, 100);
            } else {

                // Clear the sessionStorage flag once we've prevented the clear
                if (isLoadingSpecificChat) {
                    sessionStorage.removeItem('isLoadingSpecificChat');
                }
            }
        }
    }, [newConversation, location.search])

    const [formatSidebar, setFormatSideBar] = useState([]);

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.log('[Effect] getConversationData changed');
        if (getConversationData) {
            let format = getConversationData ? Object.entries(getConversationData)?.map((res, index) => {
                return {
                    key: `${index}`,
                    label: res[0]?.charAt(0)?.toUpperCase() + res[0]?.slice(1),
                    children: res[1]?.map((child, childInx) => {
                        return {
                            key: `${child?.chat_id}`,
                            label: child?.chat_name,
                            has_bookmark: child?.has_bookmark,
                        }
                    })
                }
            }) : []
            setFormatSideBar(format)

            // Persist the latest chat id (most recent) for this workspace so other components
            // can attempt a redirect after workspace/impersonation switches.
            try {
                const firstGroup = format && format.length > 0 ? format[0] : null;
                const latestChatId = firstGroup && firstGroup.children && firstGroup.children.length > 0 ? firstGroup.children[0].key : null;
                if (latestChatId) {
                    localStorage.setItem('latest_chat_id', latestChatId);
                } else {
                    localStorage.removeItem('latest_chat_id');
                }
                // Only auto-navigate to latest chat if:
                // 1. There's no chat currently open
                // 2. There's a latest chat available
                // 3. We're not explicitly on a clean /conversation URL (no chatid param means user wants new conversation)
                const urlParams = new URLSearchParams(location.search);
                const hasExplicitChatId = urlParams.has('chatid');

                if (!chatId && latestChatId && !location.pathname.includes('/conversation')) {
                    // Only auto-load latest chat when NOT on conversation page
                    // This prevents loading latest chat when user clicks "Ask Oogwai"
                    navigate(`/conversation?chatid=${latestChatId}`, { replace: true });
                }
            } catch (e) {
                console.warn('Failed to persist latest_chat_id:', e);
            }
        }
    }, [getConversationData, location.pathname, location.search])


    // const chatData = conversationData
    const { data: getStatus, isLoading: statusLoading } = useGetAnalyticStatusQuery(getCurrentWorkspaceObjectId()); // CHECK IF THE INTEGRATION IS ACTIVE

    const listCustomIntegrationData = useMemo(() => {
        if (!listCustomBigQueryData || !listCustomBigQueryData.dataset_id) {
            return {};
        }

        const output = {
            property_ids: Object.keys(listCustomBigQueryData || {}),
            property_names: Object.entries(listCustomBigQueryData || {}).map(([key, value]) => ({
                propertyId: value,
                propertyName: value,
                datasetName: value?.dataset_id,
                integrationType: "Custom"
            }))
        };

        return output;
    }, [listCustomBigQueryData]);

    const [questionQuery, setQuestionQuery] = useState(true);

    // Utility: shallow ordered array equality check
    const arraysEqual = useCallback((a = [], b = []) => {
        if (a === b) return true;
        if (!Array.isArray(a) || !Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }, []);

    // When workspace changes, reset initialization and clear selections
    const prevWorkspaceObjIdRef = useRef(workspaceObjectId);
    useEffect(() => {
        if (prevWorkspaceObjIdRef.current !== workspaceObjectId) {
            // eslint-disable-next-line no-console
            // console.log('[Effect] workspace changed, resetting defaults', { from: prevWorkspaceObjIdRef.current, to: workspaceObjectId });
            preferencesLoadedRef.current = false; // allow re-initialization for new workspace
            // Clear selected properties so sync effect can repopulate for this workspace
            setCustomPropertyId([]);
            setGaPropertyId([]);
            setShopifyPropertyId([]);
            setMetaPropertyId([]);
            setAdsPropertyId([]);
            setYoutubePropertyId([]);
            setYoutubeChannelId([]);
            // Clear current chat context
            setChatId("");
            setHistoryEnable(false);
            // Clear persisted latest chat id for the previous workspace to avoid stale redirects
            try { localStorage.removeItem('latest_chat_id'); } catch (e) { /* ignore */ }
            prevWorkspaceObjIdRef.current = workspaceObjectId;
        }
    }, [workspaceObjectId]);

    // Merge analytics and custom integration data once, memoized
    const listIntegrationData = useMemo(() => ({
        property_ids: [
            ...(listAnalyticsData?.property_ids || []),
            ...(listCustomIntegrationData?.property_ids || [])
        ],
        property_names: [
            ...(listAnalyticsData?.property_names || []),
            ...(listCustomIntegrationData?.property_names || [])
        ]
    }), [
        listAnalyticsData?.property_ids,
        listAnalyticsData?.property_names,
        listCustomIntegrationData?.property_ids,
        listCustomIntegrationData?.property_names
    ]);

    // Save selected properties to storage (legacy key + workspace-scoped key)
    const handleSaveDefaultProperties = useCallback((override) => {
        const allSelectedIds = [
            ...(override?.customPropertyId || customPropertyId),
            ...(override?.gaPropertyId || gaPropertyId),
            ...(override?.shopifyPropertyId || shopifyPropertyId),
            ...(override?.metaPropertyId || metaPropertyId),
            ...(override?.adsPropertyId || adsPropertyId),
            ...(override?.youtubePropertyId || youtubePropertyId),
            ...(override?.youtubeChannelId || youtubeChannelId)
        ];

        const payload = {
            property_ids: allSelectedIds,
            property_names: listIntegrationData?.property_names
                ?.filter(item => allSelectedIds.includes(item.propertyId))
                ?.map(item => ({
                    ...item,
                    propertyName: item.propertyName?.trim() ? item.propertyName : item.propertyId
                }))
        };

        // Legacy localStorage key for backward compatibility
        const workspaceId = localStorage.getItem("workspace_id");
        const localStorageKey = `conversation_accounts_${workspaceId}`;
        const accountPreferences = {
            customPropertyId: override?.customPropertyId || customPropertyId,
            gaPropertyId: override?.gaPropertyId || gaPropertyId,
            shopifyPropertyId: override?.shopifyPropertyId || shopifyPropertyId,
            metaPropertyId: override?.metaPropertyId || metaPropertyId,
            adsPropertyId: override?.adsPropertyId || adsPropertyId,
            youtubePropertyId: override?.youtubePropertyId || youtubePropertyId,
            youtubeChannelId: override?.youtubeChannelId || youtubeChannelId,
            timestamp: new Date().toISOString()
        };
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(accountPreferences));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Failed saving legacy preferences', e);
        }

        // New workspace-scoped storage
        saveSelectedAccountsToStorage(payload);

        if (allSelectedIds.length === 0) {
            toast.warning("2. Please select the data source", { id: 'default-properties-saved' });
        } else {
            // toast.success("Selected data sources saved successfully", { id: 'default-properties-saved' });
        }
    }, [customPropertyId, gaPropertyId, shopifyPropertyId, metaPropertyId, adsPropertyId, youtubePropertyId, youtubeChannelId, listIntegrationData?.property_names]);

    // Polling for real-time status updates
    const { data: getQueryStatus } = useGetQuestionQueryStatusQuery('', {
        pollingInterval: 3000,
        skip: questionQuery
    })

    // Current status from polling
    const currentQueryStatus = useMemo(() => {
        return getQueryStatus;
    }, [getQueryStatus]);

    const [sendPromtApi] = useLazySendFeedBackQuestionQuery();
    const [pinnedChat, setPinnedChat] = useState({});
    const [bookMark, { isSuccess: bookmarkSuccess, isError: bookmarkError, error: bookmarkErrorData }] = useBookMarkConversationMutation();
    const [history, setHistory] = useState(true);
    const [bookmarkPayload, setBookmarkPayload] = useState(null);
    const [editableQuestion, setEditableQuestion] = useState(null);
    const [editQuestion, setEditQuestion] = useState(null);
    const [editQuestionQyery] = useLazyEditQuestionQuery();
    const [useHistoryToggle, setUseHistoryToggle] = useState(true);
    const [thumbsAction, setThumbsAction] = useState({
        open: false,
        status: null,
        time: null,
        comment: "",
        method: "add",
        type: ""
    })

    const [updateHistory] = useUpdateHistoryOrNotMutation();
    const [updateChatName] = useUpdateChatNameMutation();
    const [deleteChatHistory] = useDeleteChatHistoryMutation();
    const [removeBookmark] = useRemoveBookmarkMutation();
    const [deleteBookmark, { isLoading: isDeleteBookmarkLoading, isSuccess: deleteBookmarkSuccess, isError: deleteBookmarkError, error: deleteBookmarkErrorData }] = useDeleteBookMarkInConversationMutation();
    const [deleteBookmarkPayload, setDeleteBookmarkPayload] = useState(null);
    const [historyEnable, setHistoryEnable] = useState(false);

    const [createDashboard, { isLoading: isCreateDashboardLoading }] = useCreateDashboardMutation();


    // Form for creating dashboard
    const dashboardMethods = useForm({
        defaultValues: {
            dashboard_name: ''
        }
    });


    const methods = useForm({
        // mode: 'onChange',
        defaultValues: {
            Daily_Conversion_Rate: true,
            Trend: true,
            frequency: '15days',
            property_id: listAnalyticsData?.length ? listAnalyticsData[0] : '',
            dashboard_name: dashboardNamesData?.dashboard_names ? dashboardNamesData?.dashboard_names[0] : '',
            custom_name: ""
        }
    });

    const { control, getValues, setValue, watch } = methods;


    const defaultValues = {
        new_chat_name: '',
        chat_id: "",
    };
    const {
        handleSubmit,
        control: newChatControl,
        formState: { errors },
        setValue: newChatSetValue
    } = useForm({
        defaultValues,
    });



    // Watch for changes in property_id
    const propertyId = watch('property_id') || [];
    const dashboardName = watch('dashboard_name') || '';


    const {
        isOpen: isBookmarkOpen,
        openModal: openBookmarkModal,
        closeModal: closeBookmarkModal,
        modalData: bookmarkModalData
    } = useModal();

    const {
        isOpen: isEditChatOpen,
        openModal: openEditChatModal,
        closeModal: closeEditChatModal,
        modalData: editChatModalData
    } = useModal();

    const {
        isOpen: isDeleteChatOpen,
        openModal: openDeleteChatModal,
        closeModal: closeDeleteChatModal,
        modalData: editDeleteModalData
    } = useModal();

    const handleBookmark = (response) => {
        openBookmarkModal('bookmark');
        setPinnedChat(response)
    };


    const deleteBookmarkFn = (response) => {
        const reqmodel = {
            chat_id: chatId,
            chat_timestamp: response?.timestamp,
        };
        setDeleteBookmarkPayload(reqmodel);
        deleteBookmark(reqmodel);
    }

    const handleSaveBookmark = () => {
        const reqmodel = {
            Daily_Conversion_Rate: methods.getValues('Daily_Conversion_Rate'),
            Trend: methods.getValues('Trend'),
            frequency: methods.getValues('frequency'),
            chat_id: chatId,
            chat_timestamp: pinnedChat?.timestamp,
            custom_name: methods.getValues('custom_name'),
            dashboard_name: dashboardName || '',
        };
        setBookmarkPayload(reqmodel);
        bookMark(reqmodel);
    };

    useEffect(() => {
        if (bookmarkSuccess && bookmarkPayload) {
            closeBookmarkModal();
            getChatHistory(chatId);
            toast.success("Pinned successfully");
            setBookmarkPayload(null);
        }
        if (bookmarkError && bookmarkPayload) {
            const errorMessage = bookmarkErrorData && 'data' in bookmarkErrorData ?
                bookmarkErrorData?.data?.error || 'Unexpected error' :
                'Unexpected error';
            toast.error(errorMessage);
            setBookmarkPayload(null);
        }
    }, [bookmarkSuccess, bookmarkError, bookmarkErrorData, bookmarkPayload, closeBookmarkModal, getChatHistory, chatId]);

    useEffect(() => {
        if (deleteBookmarkSuccess && deleteBookmarkPayload) {
            getChatHistory(chatId);
            toast.success("UnPinned successfully");
            setDeleteBookmarkPayload(null);
        }
        if (deleteBookmarkError && deleteBookmarkPayload) {
            const errorMessage = deleteBookmarkErrorData && 'data' in deleteBookmarkErrorData ?
                deleteBookmarkErrorData?.data?.error || 'Unexpected error' :
                'Unexpected error';
            toast.error(errorMessage);
            setDeleteBookmarkPayload(null);
        }
    }, [deleteBookmarkSuccess, deleteBookmarkError, deleteBookmarkErrorData, deleteBookmarkPayload, getChatHistory, chatId]);

    const bottomScrollRef = useRef(null);

    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] questionQuery changed', { questionQuery });
        // Only scroll to bottom if there's no message_id parameter
        const urlParams = new URLSearchParams(location.search);
        const messageId = urlParams.get('message_id');
        if (!messageId) {
            bottomScrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [questionQuery, location.search]);

    // Handle prefilled question from navigation state once, then clear the state to avoid loops
    const handledLocationQuestionRef = useRef(false);
    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] location.state.question changed', { q: location?.state?.question });
        const q = location?.state?.question;
        if (!handledLocationQuestionRef.current && q) {
            handledLocationQuestionRef.current = true;
            setValue("questionInput", q);
            handleQuestion(q, chatId);
            // Clear state without changing URL to prevent re-triggering
            navigate(location.pathname + location.search, { replace: true, state: {} });
        }
    }, [location?.state?.question]);

    const [askGoogleAnayticsQuestion, { isFetching: isQuestionLoading, data: questionData }] = useLazyAskGoogleAnalyticsQuestionQuery({
        refetchOnMountOrArgChange: true,
    });

    // Initialize SSE streaming hook
    const { streamData, currentChunk, isStreaming, error: streamError, startStream, stopStream } = useSSEStream();
    // console.log("📊 [SSE State]", {
    //     isStreaming,
    //     currentChunkLength: currentChunk?.length,
    //     currentChunkPreview: currentChunk?.substring(0, 50),
    //     dataLength: data?.length,
    //     lastMessageStreaming: data?.length > 0 ? data[data.length - 1]?.streaming : null,
    //     lastMessageTextLength: data?.length > 0 && data[data.length - 1]?.chat?.[0] ? data[data.length - 1].chat[0].text_response?.length : 0,
    //     lastMessagePreview: data?.length > 0 && data[data.length - 1]?.chat?.[0] ? data[data.length - 1].chat[0].text_response?.substring(0, 50) : null
    // });

    // Auto-scroll during streaming
    useEffect(() => {
        // Only auto-scroll during streaming if there's no message_id parameter
        const urlParams = new URLSearchParams(location.search);
        const messageId = urlParams.get('message_id');

        if (isStreaming && currentChunk && !messageId) {
            // console.log('📜 [Auto-scroll] Scrolling to bottom, chunk length:', currentChunk.length);
            // Smooth scroll to bottom as chunks arrive
            chatMessagesRef.current?.lastElementChild?.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, [currentChunk, isStreaming, location.search]);

    // Remove justCompleted flag after animation completes
    useEffect(() => {
        const timer = setTimeout(() => {
            setData(prev => prev.map(msg =>
                msg.justCompleted ? { ...msg, justCompleted: false } : msg
            ));
        }, 600); // Match animation duration (500ms + buffer)

        return () => clearTimeout(timer);
    }, [data.length]); // Run when data length changes (new message added)

    // Combined loading state for both API and SSE streaming
    const isLoading = useMemo(() => isQuestionLoading || isStreaming, [isQuestionLoading, isStreaming]);

    // Parse chatid from URL parameters and load chat history
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const urlChatId = urlParams.get('chatid');
        const message_id = urlParams.get('message_id');

        // console.log('🔍 [Effect] URL chatId changed', {
        //     urlChatId,
        //     currentChatId: chatId,
        //     fromStreaming: chatIdFromStreamingRef.current
        // });

        if (urlChatId && urlChatId !== chatId) {
            setChatId(urlChatId);

            // Skip getChatHistory if this chatId came from streaming completion
            // (we already have the data from streaming, no need to refetch)
            if (chatIdFromStreamingRef.current) {
                chatIdFromStreamingRef.current = false; // Reset flag
            } else {

                // MUST clear data immediately to prevent showing wrong chat's history
                setData([]);
                lastLoadedChatIdRef.current = null; // Reset so new chat can load immediately
                pendingChatIdRef.current = urlChatId; // Track which chatId we're loading

                // Handle the API response directly to avoid RTK Query cache issues
                getChatHistory(urlChatId)
                    .unwrap()
                    .then((response) => {

                        // Verify this response is still for the current chatId (avoid race conditions)
                        const currentUrlParams = new URLSearchParams(location.search);
                        const currentChatId = currentUrlParams.get('chatid');

                        if (currentChatId === urlChatId && response?.history) {
                            setData(response.history);
                            lastLoadedChatIdRef.current = urlChatId;
                            pendingChatIdRef.current = null;

                            // Scroll after loading - check for message_id parameter
                            setTimeout(() => {
                                if (message_id) {
                                    // Try to scroll to specific message
                                    const targetElement = document.getElementById(`chat-${message_id}`);
                                    if (targetElement) {
                                        // Scroll to element with offset to prevent clipping
                                        const elementPosition = targetElement.getBoundingClientRect().top;
                                        const offsetPosition = elementPosition + window.pageYOffset - 150; // 80px offset from top

                                        window.scrollTo({
                                            top: offsetPosition,
                                            behavior: "smooth"
                                        });

                                        // Add highlight effect
                                        targetElement.style.transition = 'background-color 0.5s ease-in-out';
                                        targetElement.style.backgroundColor = '#f0f9ff';
                                        targetElement.style.borderRadius = '8px';
                                        setTimeout(() => {
                                            targetElement.style.backgroundColor = '';
                                            setTimeout(() => {
                                                targetElement.style.transition = '';
                                                targetElement.style.borderRadius = '';
                                            }, 500);
                                        }, 2000);
                                    } else {
                                        // Message not found, scroll to bottom
                                        chatMessagesRef.current?.lastElementChild?.scrollIntoView({ behavior: "smooth" });
                                    }
                                } else {
                                    // No message_id, scroll to bottom as usual
                                    chatMessagesRef.current?.lastElementChild?.scrollIntoView({ behavior: "smooth" });
                                }
                            }, 100);
                        } else {
                            console.warn('⚠️ [getChatHistory] Ignoring stale response for chatId:', urlChatId);
                        }
                    })
                    .catch((error) => {
                        console.error('❌ [getChatHistory] API Error:', error);
                        pendingChatIdRef.current = null;
                    });

                // Reset user modification flag so data sources can sync from chat history
                // (But only if not currently streaming to preserve active session selections)
                if (!isStreaming) {
                    console.log('🔄 [Effect] Sidebar chat clicked, allowing data source sync from history');
                    setUserModifiedDataSources(false);
                }
            }
        }
    }, [location.search, chatId, getChatHistory, isStreaming]);


    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('🔍 [Effect] chatData changed!', {
        //     hasChatData: !!chatData,
        //     hasHistory: !!chatData?.history,
        //     historyLength: chatData?.history?.length,
        //     chatId: chatId,
        //     chatIdEmpty: chatId === "",
        //     newConversation: newConversation,
        //     isStreaming: isStreaming,
        //     currentDataLength: data.length,
        //     lastLoadedChatId: lastLoadedChatIdRef.current
        // });

        // Check if any message is currently streaming (not just completed - that's okay to override)
        const hasActiveStreamingMessage = data.some(msg => msg.streaming);

        // Verify chatData matches the chatId we're trying to load (prevent race conditions)
        const chatDataMatchesPending = pendingChatIdRef.current === chatId;

        // Only use this effect for page refresh scenarios (when data is empty)
        // Sidebar clicks are now handled directly in the URL effect via promise
        // Load chat history if:
        // 1. We have chat history data
        // 2. We have a valid chatId
        // 3. It's not a new conversation
        // 4. NOT actively streaming (prevent overwriting streaming messages)
        // 5. Haven't already loaded this chatId (prevents duplicate loads)
        // 6. The chatData matches the pending chatId (prevents race conditions)
        // 7. Data is empty (page refresh scenario - sidebar clicks handled elsewhere)
        const chatIdChanged = chatId !== lastLoadedChatIdRef.current;
        const shouldLoadHistory = chatData?.history &&
            chatId !== "" &&
            !newConversation &&
            !isStreaming &&
            chatIdChanged &&
            !hasActiveStreamingMessage &&
            chatDataMatchesPending &&
            data.length === 0; // Only for page refresh

        if (shouldLoadHistory) {
            // console.log('✅ [Effect] Updating data state with chat history!', {
            //     historyLength: chatData.history.length,
            //     reason: data.length === 0 ? 'Page refresh/initial load' : 'Sidebar navigation',
            //     previousChatId: lastLoadedChatIdRef.current,
            //     newChatId: chatId,
            //     pendingChatId: pendingChatIdRef.current
            // });
            setData(chatData?.history);
            lastLoadedChatIdRef.current = chatId; // Mark this chatId as loaded
            pendingChatIdRef.current = null; // Clear pending flag after successful load
            // Check for message_id parameter to scroll to specific chat
            const urlParams = new URLSearchParams(location.search);
            const message_id = urlParams.get('message_id');

            // Reduced timeout for faster chat switching experience
            setTimeout(() => {
                if (message_id) {
                    // Try to find and scroll to the specific chat message
                    const targetElement = document.getElementById(`chat-${message_id}`);
                    if (targetElement) {
                        // Scroll to element with offset to prevent clipping
                        const elementPosition = targetElement.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - 80; // 80px offset from top

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth"
                        });

                        // Add smooth transition for highlight
                        targetElement.style.transition = 'background-color 0.5s ease-in-out';
                        targetElement.style.backgroundColor = '#f0f9ff';
                        targetElement.style.borderRadius = '8px';
                        setTimeout(() => {
                            targetElement.style.backgroundColor = '';
                            // Remove transition and border radius after animation completes
                            setTimeout(() => {
                                targetElement.style.transition = '';
                                targetElement.style.borderRadius = '';
                            }, 500);
                        }, 2000);
                    } else {
                        chatMessagesRef.current?.lastElementChild?.scrollIntoView({ behavior: "smooth" });
                    }
                } else {
                    // No message_id parameter, scroll to bottom as usual
                    chatMessagesRef.current?.lastElementChild?.scrollIntoView({ behavior: "smooth" });
                }
            }, 100)
        } else {
            // console.warn('⚠️ [Effect] NOT updating data state because:', {
            //     reason: !chatData?.history ? 'No history in chatData' :
            //             chatId === "" ? 'chatId is empty' :
            //             newConversation ? 'newConversation is true' :
            //             isStreaming ? 'Currently streaming (prevents overwriting)' :
            //             !chatIdChanged ? 'Already loaded this chatId' :
            //             hasActiveStreamingMessage ? 'Has active streaming message (prevents overwriting)' :
            //             !chatDataMatchesPending ? `ChatData doesn't match pending chatId (pending: ${pendingChatIdRef.current}, current: ${chatId})` :
            //             data.length > 0 ? 'Data already loaded (sidebar clicks handled via promise)' : 'Unknown',
            //     shouldLoadHistory: shouldLoadHistory,
            //     conditions: {
            //         hasHistory: !!chatData?.history,
            //         hasChatId: chatId !== "",
            //         notNewConversation: !newConversation,
            //         notStreaming: !isStreaming,
            //         chatIdChanged: chatIdChanged,
            //         noActiveStreaming: !hasActiveStreamingMessage,
            //         chatDataMatchesPending: chatDataMatchesPending,
            //         dataEmpty: data.length === 0
            //     }
            // });
        }
    }, [chatData, location.search, chatId, newConversation, isStreaming, data.length])

    const handleTicker = (data, chartType = null) => {
        if (!data || !data.length) return {};

        const sampleItem = data[0];
        if (!sampleItem) return {};

        const keys = Object.keys(sampleItem);

        // Dynamically determine field types by analyzing actual data
        const fieldAnalysis = keys.map(key => {
            // Check if field is numeric across all items
            const isNumeric = data.every(item =>
                item[key] === null ||
                item[key] === undefined ||
                typeof item[key] === 'number' ||
                (!isNaN(parseFloat(item[key])) && isFinite(item[key]))
            );

            // Calculate uniqueness ratio (for identifying good label fields)
            const uniqueValues = new Set(data.map(item => item[key]));
            const uniquenessRatio = uniqueValues.size / data.length;

            // Check if it looks like a date/time field
            const sampleValue = String(data[0][key]);
            const isDateTime = !isNumeric && (
                /^\d{4}-\d{2}-\d{2}/.test(sampleValue) || // ISO date
                /^\d{1,2}\/\d{1,2}\/\d{2,4}/.test(sampleValue) || // MM/DD/YYYY
                /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)/i.test(sampleValue) // Month names
            );

            // For numeric fields, calculate the range
            let range = 0;
            let sum = 0;
            if (isNumeric) {
                const numericValues = data.map(item => parseFloat(item[key]) || 0);
                const min = Math.min(...numericValues);
                const max = Math.max(...numericValues);
                range = max - min;
                sum = numericValues.reduce((a, b) => a + b, 0);
            }

            return {
                key,
                isNumeric,
                isDateTime,
                uniquenessRatio,
                range,
                sum,
                uniqueCount: uniqueValues.size
            };
        });

        // Separate fields by type
        const numericFields = fieldAnalysis.filter(f => f.isNumeric);
        const textFields = fieldAnalysis.filter(f => !f.isNumeric && !f.isDateTime);
        const dateFields = fieldAnalysis.filter(f => f.isDateTime);

        // For pie/donut charts
        if (chartType === 'pie_chart' || chartType === 'donut_chart') {
            // For value field: Choose the numeric field with the most meaningful values
            // Prefer fields where values sum to 100 (likely percentages) or have good variance
            let valueField = null;

            if (numericFields.length > 0) {
                // Check if any field sums to approximately 100 (percentage field)
                const percentageField = numericFields.find(f =>
                    Math.abs(f.sum - 100) < 1 || // Sum is close to 100
                    data.every(item => {
                        const val = parseFloat(item[f.key]) || 0;
                        return val >= 0 && val <= 100; // All values between 0-100
                    })
                );

                if (percentageField) {
                    valueField = percentageField.key;
                } else {
                    // Choose the numeric field with the best range (most variance)
                    // This likely represents the main metric
                    const sortedByRange = [...numericFields].sort((a, b) => b.range - a.range);
                    valueField = sortedByRange[0]?.key;
                }
            }

            // For label field: Choose the text field with the highest uniqueness
            // (most distinct values = best for categorization)
            let labelField = null;

            if (textFields.length > 0) {
                // Sort by uniqueness (fields with more unique values are better labels)
                const sortedByUniqueness = [...textFields].sort((a, b) =>
                    b.uniqueCount - a.uniqueCount
                );
                labelField = sortedByUniqueness[0]?.key;
            } else {
                // Fallback to first non-numeric key
                labelField = keys.find(k => !numericFields.some(f => f.key === k)) || keys[0];
            }

            return {
                xLabel: labelField,
                yLabel: valueField,
                xAxis: labelField,
                yAxis: valueField
            };
        }

        // For scatter plots - require numeric fields for both axes
        if (chartType === 'scatter_plot') {
            if (numericFields.length >= 2) {
                // Use first two numeric fields for scatter plot
                const xAxis = numericFields[0]?.key;
                const yAxis = numericFields[1]?.key;

                return {
                    xLabel: xAxis,
                    yLabel: yAxis,
                    xAxis: xAxis,
                    yAxis: yAxis
                };
            } else {
                // Fallback if not enough numeric fields
                return {
                    xLabel: numericFields[0]?.key || keys[0],
                    yLabel: numericFields[1]?.key || keys[1],
                    xAxis: numericFields[0]?.key || keys[0],
                    yAxis: numericFields[1]?.key || keys[1]
                };
            }
        }

        // For other charts (bar, line, etc.)
        // Use date field as x-axis if available (time series)
        const xAxis = dateFields[0]?.key ||
            (textFields[0]?.key) || // Use text field if no date
            keys[0]; // Fallback to first key

        // For y-axis: use numeric fields that aren't the x-axis
        const yAxisCandidates = numericFields.filter(f => f.key !== xAxis);
        const yAxis = yAxisCandidates.length > 1
            ? yAxisCandidates.map(f => f.key) // Return array for multi-series
            : yAxisCandidates[0]?.key || numericFields[0]?.key || keys[1];

        return {
            xLabel: xAxis,
            yLabel: yAxis,
            xAxis: xAxis,
            yAxis: yAxis
        };
    }

    const handleVisualModal = (modalType, modalState = false, response, timestamp = '') => {

        // If response is an array, wrap it in an object with data property
        const modalData = Array.isArray(response)
            ? { data: response, timestamp }
            : { ...response, timestamp };

        // Track GA4 events for expand/collapse
        if (modalState) {
            // Expanding
            const visualTag = response?.visual_tag || 'unknown';
            ReactGA.event('visual_expanded', {
                visual_type: modalType, // 'graph' or 'table'
                chart_type: visualTag,
                chat_id: chatId,
            });
        } else if (modalType !== null) {
            // Collapsing (only track if modalType is not null to avoid tracking on unmount)
            ReactGA.event('visual_collapsed', {
                chat_id: chatId,
            });
        }

        setOpenVisualModal({
            state: modalState,
            type: modalType,
            response: modalData
        });
    }

    const agentName = (agent) => {
        switch (agent) {
            case 'meta':
                return 'Meta';
            case 'googleads':
                return 'Google Ads';
            case 'shopify':
                return 'Shopify';
            case 'googleanalytics':
                return 'Google Analytics';
            case 'custom_bigquery':
                return 'Custom Big Query';
            default:
                return null;
        }
    }

    const renderAgentlogo = (agent) => {
        if (agent === 'meta') return agentIconsSmall.Meta;
        if (agent === 'googleads') return agentIconsSmall.GoogleAds;
        if (agent === 'shopify') return agentIconsSmall.Shopify;
        if (agent === 'googleanalytics') return agentIconsSmall.GA4;
        if (agent === 'custom_bigquery') return agentIconsSmall.Custom;
        return '';
    }

    const handleVisualTag = (response) => {
        const dataTimestamp = response?.timestamp;

        return response?.chat?.map((chatItem, chatIndex) => {
            const data = chatItem?.data || {};
            const visualTags = Object.keys(data); // all possible visual tags inside `data`

            // Normalize text response handling
            const TextResponse = ({ className, source }) => {
                if (!source?.text_response && !source?.thumbnail_image) return null;

                if (source?.agent === 'System') {
                    return (
                        <div className={`flex flex-row pb-3 ${className || ""}`}>
                            <div className="bg-red-50 border border-red-200 rounded-lg p-4 w-full">
                                <p className="text-sm text-red-700 whitespace-pre-wrap break-words leading-relaxed">
                                    {source?.text_response || 'Something went wrong. Please try again.'}
                                </p>
                            </div>
                        </div>
                    );
                }

                let { text_response } = source;

                if (typeof text_response === "object" && text_response !== null) {
                    if ("link clicks" in text_response || "post engagements" in text_response) {
                        const entries = Object.entries(text_response);
                        text_response = entries.map(([key, value]) => `${key}: ${value}`).join(", ");
                    } else {
                        text_response = JSON.stringify(text_response);
                    }
                }

                const textContent = String(text_response || "");

                // Parse **...** markdown bold syntax
                const renderTextWithBold = (text) => {
                    const boldRegex = /\*\*([^*]+)\*\*/g;
                    const parts = [];
                    let lastIndex = 0;
                    let match;

                    while ((match = boldRegex.exec(text)) !== null) {
                        // Add text before the match
                        if (match.index > lastIndex) {
                            parts.push({
                                text: text.slice(lastIndex, match.index),
                                isBold: false
                            });
                        }
                        // Add the bold text (without the ** markers)
                        parts.push({
                            text: match[1],
                            isBold: true
                        });
                        lastIndex = match.index + match[0].length;
                    }

                    // Add remaining text after last match
                    if (lastIndex < text.length) {
                        parts.push({
                            text: text.slice(lastIndex),
                            isBold: false
                        });
                    }

                    // If no bold markers found, return plain text
                    if (parts.length === 0) {
                        return text;
                    }

                    return parts.map((part, index) => {
                        if (part.isBold) {
                            return (
                                <span key={index} className="text-text-700 font-semibold">
                                    {part.text}
                                </span>
                            );
                        }
                        return <span key={index}>{part.text}</span>;
                    });
                };

                return (
                    <div className={`flex flex-col pb-3 ${className || ""}`}>
                        <p className="font-normal text-sm text-text-600 whitespace-pre-wrap break-words">
                            {renderTextWithBold(textContent)}
                        </p>
                        {source?.thumbnail_image && (
                            <img
                                src={`data:image/png;base64,${source.thumbnail_image}`}
                                alt="Thumbnail"
                                 className="mt-2 max-w-full rounded-lg border border-gray-200"
                            />
                        )}
                    </div>
                );
            };

            // Helper function to get property IDs for this chat item's agent
            const getPropertyIdsForAgent = () => {
                const agent = chatItem?.agent;
                const messageData = response;

                switch (agent) {
                    case 'googleanalytics':
                        return messageData?.property_id ? (Array.isArray(messageData.property_id) ? messageData.property_id : messageData.property_id.split(',').filter(id => id)) : [];
                    case 'meta':
                        return messageData?.meta_id ? (Array.isArray(messageData.meta_id) ? messageData.meta_id : messageData.meta_id.split(',').filter(id => id)) : [];
                    case 'googleads':
                        return messageData?.google_ads_id ? (Array.isArray(messageData.google_ads_id) ? messageData.google_ads_id : messageData.google_ads_id.split(',').filter(id => id)) : [];
                    case 'shopify':
                        return messageData?.shopify_id ? (Array.isArray(messageData.shopify_id) ? messageData.shopify_id : messageData.shopify_id.split(',').filter(id => id)) : [];
                    case 'custom':
                        return messageData?.custom_bq_tool ? (Array.isArray(messageData.custom_bq_tool) ? messageData.custom_bq_tool : messageData.custom_bq_tool.split(',').filter(id => id)) : [];
                    default:
                        return [];
                }
            };

            const propertyIds = getPropertyIdsForAgent();

            return (
                <div key={chatIndex} className="pt-3 pb-2">
                    {agentName(chatItem?.agent) && (
                        <p className="text-overflow-ellipsis text-[#717680] font-medium flex items-center gap-1 mb-1">
                            Data Source : {agentName(chatItem?.agent)}{" "}
                            {propertyIds.length > 0 ? (
                                <Dropdown
                                    trigger={['click']}
                                    dropdownRender={() => (
                                        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-3 min-w-[280px]">
                                            <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-200">
                                                {renderAgentlogo(chatItem?.agent)}
                                                <span className="text-sm font-semibold text-gray-700">{agentName(chatItem?.agent)}</span>
                                            </div>
                                            <div className="text-xs font-semibold text-gray-500 mb-2">Property IDs Used:</div>
                                            <div className="max-h-[200px] overflow-y-auto">
                                                {propertyIds.map((id, idx) => (
                                                    <div key={idx} className="py-1.5 px-2 text-sm text-gray-700 hover:bg-gray-50 rounded mb-1 break-all">
                                                        {id}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                >
                                    <span className="cursor-pointer inline-flex items-center hover:opacity-70 transition-opacity">
                                        {renderAgentlogo(chatItem?.agent)}
                                    </span>
                                </Dropdown>
                            ) : (
                                renderAgentlogo(chatItem?.agent)
                            )}
                        </p>
                    )}

                    {/* Always render text response first */}
                    <TextResponse className="" source={chatItem} />

                    {/* Loop over all available visual tags inside data */}
                    {/* Wrap in flex container if there are 2 or more visualizations */}
                    {(() => {
                        // Check if pie or donut chart exists in visualTags
                        const hasPieChart = visualTags.includes('pie_chart');
                        const hasDonutChart = visualTags.includes('donut_chart');
                        const hasTable = visualTags.includes('table');

                        // For table + pie/donut combination, use custom grid template
                        const useCustomGrid = visualTags.length === 2 && hasTable && (hasPieChart || hasDonutChart);

                        return (
                            <div className={
                                visualTags.length >= 2
                                    ? `grid grid-cols-1 ${visualTags.length === 2
                                        ? useCustomGrid
                                            ? 'md:grid-cols-[1.5fr,1fr]'  // Table gets 60%, chart gets 40%
                                            : 'md:grid-cols-2'
                                        : 'md:grid-cols-3'
                                    } gap-4 w-full items-start`
                                    : "w-full"
                            }>
                                {visualTags.map((tag, i) => {
                                    const actualData = Array.isArray(data[tag]) ? data[tag] : [];
                                    const hasMoreKeys =
                                        actualData?.length > 0
                                            ? actualData.some((item) => Object.keys(item)?.length > 2)
                                            : false;

                                    // Check if x-axis has many data points (more than 8 items means crowded x-axis)
                                    const hasLotOfXAxisData = actualData?.length > 8;
                                    const shouldTake2Columns = hasLotOfXAxisData && visualTags.length >= 2;

                                    // Dynamic column span based on number of visualizations
                                    let columnSpan = "";
                                    if (visualTags.length === 1) {
                                        // Single visualization takes 2 out of 3 columns
                                        columnSpan = "md:col-span-2";
                                    } else if (visualTags.length === 2) {
                                        // Two visualizations: each takes 1 column (50% width)
                                        columnSpan = "md:col-span-1";
                                    } else {
                                        // Three or more: use default grid behavior
                                        columnSpan = "";
                                    }

                                    switch (tag) {
                                        case "bar_chart":
                                            // Check if there are many data points that would cause crowded x-axis
                                            const hasManyDataPoints = actualData && actualData.length > 15;
                                            return (
                                                <div key={i} className={
                                                    hasManyDataPoints
                                                        ? "col-span-full" // Force full width when many data points
                                                        : visualTags.length <= 2
                                                            ? columnSpan
                                                            : shouldTake2Columns
                                                                ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                                : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <div className="relative flex flex-col lg:flex-row gap-4 w-full overflow-visible">
                                                        <div className="relative w-full flex items-stretch overflow-visible">
                                                            {/* <Button
                                                        onClick={() =>
                                                            handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)
                                                        }
                                                        shape="circle"
                                                        className="absolute top-2 right-2 z-10 bg-gray-100 opacity-50 hover:opacity-100"
                                                        icon={<ExpandIcon className="w-3 h-3" />}
                                                    /> */}
                                                            <CustomChart
                                                                className="shadow-sm overflow-hidden rounded-2xl relative border border-solid border-[#e9e9eb] p-3 pl-6 w-full"
                                                                data={actualData}
                                                                type="bar-chart"
                                                                size="small"
                                                                dataXkey={handleTicker(actualData).xAxis || ""}
                                                                dataYKey={handleTicker(actualData).yAxis || ""}
                                                                yAxisLabel={handleTicker(actualData).yAxis || ""}
                                                                xAxisLabel={handleTicker(actualData).xLabel || ""}
                                                                isResponsive={true}
                                                                showExpandButton={true}
                                                                onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );

                                        case "line_graph":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : shouldTake2Columns
                                                            ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                            : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <div className="relative overflow-visible">
                                                        {/* <Button
                                                    onClick={() =>
                                                        handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)
                                                    }
                                                    shape="circle"
                                                    className="absolute top-2 right-2 z-10 bg-gray-100 opacity-50 hover:opacity-100"
                                                    icon={<ExpandIcon className="w-3 h-3" />}
                                                /> */}
                                                        <div className={`w-full ${visualTags.length >= 2 ? 'flex items-stretch' : 'overflow-x-auto'}`}>
                                                            <CustomChart
                                                                className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3 min-w-0 sm:min-w-[350px] w-full"
                                                                data={actualData}
                                                                type="line-graph"
                                                                size="small"
                                                                dataXkey={handleTicker(actualData).xLabel || ""}
                                                                dataYKey={handleTicker(actualData).yAxis || ""}
                                                                xAxisLabel={handleTicker(actualData).xLabel || ""}
                                                                yAxisLabel={handleTicker(actualData).yAxis || ""}
                                                                isResponsive={true}
                                                                showExpandButton={true}
                                                                onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );

                                        case "table":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    {actualData.length > 0 && (
                                                        <div className="relative flex-1 w-full overflow-hidden" style={{ minWidth: '260px' }}>
                                                            <Button
                                                                onClick={() =>
                                                                    handleVisualModal(
                                                                        "table",
                                                                        true,
                                                                        { data: actualData, visual_tag: tag },
                                                                        dataTimestamp
                                                                    )
                                                                }
                                                                shape="circle"
                                                                className="bg-gray-100 absolute right-1 top-1 z-10 opacity-60 hover:opacity-100 transition-opacity duration-200"
                                                                icon={<ExpandIcon className="w-4 h-4" />}
                                                                title="Expand table"
                                                            />
                                                            <TableData
                                                                data={actualData}
                                                                isFetching={isChatHistoryLoading}
                                                                pageSizeLimit={5}
                                                                scrollY={visualTags.length >= 2 ? 450 : undefined}
                                                                className="min-w-0 w-full"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            );

                                        case "pie_chart":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <CustomChart
                                                        className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3"
                                                        data={actualData}
                                                        type="pie-chart"
                                                        size="small"
                                                        dataXkey={handleTicker(actualData, "pie_chart").xAxis || ""}
                                                        dataYKey={handleTicker(actualData, "pie_chart").yAxis || ""}
                                                        isResponsive={true}
                                                        showExpandButton={true}
                                                        onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                    />
                                                </div>
                                            );

                                        case "donut_chart":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <CustomChart
                                                        className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3"
                                                        data={actualData}
                                                        type="donut-chart"
                                                        size="small"
                                                        dataXkey={handleTicker(actualData, "donut_chart").xAxis || ""}
                                                        dataYKey={handleTicker(actualData, "donut_chart").yAxis || ""}
                                                        isResponsive={true}
                                                        showExpandButton={true}
                                                        onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                    />
                                                </div>
                                            );
                                        case "scatter_plot":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : shouldTake2Columns
                                                            ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                            : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <CustomChart
                                                        className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3"
                                                        data={actualData}
                                                        type="scatter-plot"
                                                        size="small"
                                                        dataXkey={handleTicker(actualData, "scatter_plot").xAxis || ""}
                                                        dataYKey={handleTicker(actualData, "scatter_plot").yAxis || ""}
                                                        xAxisLabel={handleTicker(actualData, "scatter_plot").xLabel || ""}
                                                        yAxisLabel={handleTicker(actualData, "scatter_plot").yLabel || ""}
                                                        isResponsive={true}
                                                        showExpandButton={true}
                                                        onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                    />
                                                </div>
                                            );

                                        case "geo_map":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[350px] py-3"
                                                }>
                                                    <CustomChart
                                                        className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3"
                                                        data={actualData}
                                                        type="geo-map"
                                                        size="small"
                                                        dataXkey={handleTicker(actualData, "geo_map").xAxis || ""}
                                                        dataYKey={handleTicker(actualData, "geo_map").yAxis || ""}
                                                        isResponsive={true}
                                                        showExpandButton={true}
                                                        onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                    />
                                                </div>
                                            );

                                        case "horizontal_bar_chart":
                                            return (
                                                <div key={i} className={
                                                    shouldTake2Columns
                                                        ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                        : visualTags.length >= 2
                                                            ? "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[350px] py-3"
                                                            : "py-3"
                                                }>
                                                    <CustomChart
                                                        className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3"
                                                        data={actualData}
                                                        type="horizontal-bar"
                                                        size="small"
                                                        dataXkey={handleTicker(actualData, "horizontal_bar_chart").xAxis || ""}
                                                        dataYKey={handleTicker(actualData, "horizontal_bar_chart").yAxis || ""}
                                                        isResponsive={true}
                                                        showExpandButton={true}
                                                        onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                    />
                                                </div>
                                            );

                                        case "multi_bar_chart":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : shouldTake2Columns
                                                            ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                            : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <div className="relative w-full">
                                                        <div className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3 pl-6">
                                                            {/* <Button
                                                        onClick={() =>
                                                            handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)
                                                        }
                                                        shape="circle"
                                                        className="absolute top-2 right-2 z-10 bg-gray-100 opacity-50 hover:opacity-100"
                                                        icon={<ExpandIcon className="w-3 h-3" />}
                                                    /> */}
                                                            <CustomChart
                                                                data={actualData}
                                                                type="multi_bar_chart"
                                                                size="large"
                                                                dataXkey={handleTicker(actualData).xAxis || ""}
                                                                dataYKey={handleTicker(actualData).yAxis || ""}
                                                                yAxisLabel={handleTicker(actualData).yAxis || ""}
                                                                xAxisLabel={handleTicker(actualData).xLabel || ""}
                                                                isResponsive={true}
                                                                showExpandButton={true}
                                                                onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );

                                        case "multi-bar-chart-secondary-y-axis":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : shouldTake2Columns
                                                            ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                            : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <div className="relative w-full">
                                                        <div className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3 pl-6">
                                                            <CustomChart
                                                                data={actualData}
                                                                type="multi-bar-chart-secondary-y-axis"
                                                                size="large"
                                                                dataXkey={handleTicker(actualData).xAxis || ""}
                                                                dataYKey={handleTicker(actualData).yAxis || ""}
                                                                yAxisLabel={handleTicker(actualData).yAxis || ""}
                                                                xAxisLabel={handleTicker(actualData).xLabel || ""}
                                                                isResponsive={true}
                                                                showExpandButton={true}
                                                                onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );

                                        case "line-graph-secondary-y-axis":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : shouldTake2Columns
                                                            ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                            : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <div className="relative w-full">
                                                        <div className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3 pl-6">
                                                            <CustomChart
                                                                data={actualData}
                                                                type="line-graph-secondary-y-axis"
                                                                size="large"
                                                                dataXkey={handleTicker(actualData).xAxis || ""}
                                                                dataYKey={handleTicker(actualData).yAxis || ""}
                                                                yAxisLabel={handleTicker(actualData).yAxis || ""}
                                                                xAxisLabel={handleTicker(actualData).xLabel || ""}
                                                                isResponsive={true}
                                                                showExpandButton={true}
                                                                onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );

                                        case "bar-graph-secondary-y-axis":
                                            return (
                                                <div key={i} className={
                                                    visualTags.length <= 2
                                                        ? columnSpan
                                                        : shouldTake2Columns
                                                            ? "col-span-1 md:col-span-2 lg:col-span-2"
                                                            : "flex-1 min-w-0 sm:min-w-[280px] lg:min-w-[300px]"
                                                }>
                                                    <div className="relative w-full">
                                                        <div className="shadow-sm rounded-2xl relative border border-solid border-[#e9e9eb] p-3 pl-6">
                                                            <CustomChart
                                                                data={actualData}
                                                                type="bar-graph-secondary-y-axis"
                                                                size="large"
                                                                dataXkey={handleTicker(actualData).xAxis || ""}
                                                                dataYKey={handleTicker(actualData).yAxis || ""}
                                                                yAxisLabel={handleTicker(actualData).yAxis || ""}
                                                                xAxisLabel={handleTicker(actualData).xLabel || ""}
                                                                isResponsive={true}
                                                                showExpandButton={true}
                                                                onExpand={() => handleVisualModal('graph', true, { data: actualData, visual_tag: tag }, dataTimestamp)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            );

                                        default:
                                            return null;

                                    }
                                })}
                            </div>
                        );
                    })()}
                </div>
            );
        });
    };

    const sidebarRef = useRef(null);
    const chatRef = useRef(null);
    const chatMessagesRef = useRef(null);
    const chatInputRef = useRef(null);

    const [toggleSidebar, setToggleSidebar] = useState(true);

    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] chatId or data changed (animation)', { chatId, dataLen: data?.length });
        if (chatInputRef.current) {
            gsap.to(chatInputRef.current, {
                bottom: chatId ? "0px" : "2rem",
                duration: 0.3,
                ease: "power3.out",
            });
        }

        if (chatMessagesRef.current) {
            const chatContainer = chatMessagesRef.current;
            const scrollHeight = chatContainer.scrollHeight;
            const currentHeight = chatContainer.offsetHeight;

            if (scrollHeight > currentHeight) {
                gsap.fromTo(
                    chatContainer,
                    { height: currentHeight, overflow: "hidden", willChange: "height" },
                    {
                        height: scrollHeight,
                        duration: 0.3,
                        ease: "power2.out",
                        onComplete: () => {
                            chatContainer.style.height = "auto";
                            chatContainer.style.overflow = "visible"
                        },
                    }
                );
            }
        }
    }, [chatId, data]);

    const handleQuestion = async (initialValue, chatid) => {
        console.log('🚀 [handleQuestion] Step 1: CALLED', { initialValue, chatid });
        try {
            console.log('🚀 [handleQuestion] Step 2: Getting question value...');
            const question = initialValue ? initialValue : getValues('questionInput');
            console.log('📝 [handleQuestion] Step 3: Question value:', question);

            if (!question) {
                console.log('⚠️ [handleQuestion] Step 4: No question, returning');
                return;
            }

            console.log('🚀 [handleQuestion] Step 5: Adding user question to data state...');
            // Add user's question to data immediately (optimistic update)
            // const userMessage = {
            //     agent: 'User',
            //     question: question,
            //     timestamp: Date.now()
            // };
            // setData(prev => [...prev, userMessage]);

            console.log('🚀 [handleQuestion] Step 6: Calling sendPromtApi...');
            sendPromtApi(question)
                .unwrap()
                .then((res) => {
                    console.log('✅ [handleQuestion] sendPromtApi success:', res);
                })
                .catch((err) => {
                    console.log('❌ [handleQuestion] sendPromtApi error:', err);
                })

            console.log('🚀 [handleQuestion] Step 7: Setting states...');
            // Start polling for status updates
            setQuestionQuery(false)
            setHistoryEnable(false);
            dispatch(updateNewConversation(false))

            console.log('🚀 [handleQuestion] Step 8: Clearing input field...');
            // Clear input field immediately
            setValue("questionInput", "")

            console.log('🚀 [handleQuestion] Step 9: Building payload...');
            console.log('🚀 [handleQuestion] Property IDs:', {
                gaPropertyId,
                metaPropertyId,
                adsPropertyId,
                shopifyPropertyId,
                customPropertyId
            });

            // Filter out "Not Integrated" items before sending to API
            // An item is integrated if it exists in the listIntegrationData
            const filterIntegratedOnly = (ids, integrationType) => {
                if (!ids || !Array.isArray(ids)) return [];
                return ids.filter(id => {
                    // Check if this ID exists in the integrated property list
                    const isIntegrated = listIntegrationData?.property_names?.some(
                        p => p.propertyId === id && p.integrationType === integrationType
                    );
                    return isIntegrated; // Only include properly integrated items
                });
            };

            const filteredGaPropertyId = filterIntegratedOnly(gaPropertyId, "GA4");
            const filteredMetaPropertyId = filterIntegratedOnly(metaPropertyId, "Meta");
            const filteredAdsPropertyId = filterIntegratedOnly(adsPropertyId, "GoogleAds");
            const filteredShopifyPropertyId = filterIntegratedOnly(shopifyPropertyId, "Shopify");
            const filteredCustomPropertyId = filterIntegratedOnly(customPropertyId, "Custom");

            // Build payload for SSE URL
            const payload = {
                question: question,
                meta_id: filteredMetaPropertyId?.length ? filteredMetaPropertyId.join(',') : '',
                google_ads_id: filteredAdsPropertyId?.length ? filteredAdsPropertyId.join(',') : '',
                shopify_id: filteredShopifyPropertyId?.length ? filteredShopifyPropertyId.join(',') : '',
                property_id: filteredGaPropertyId?.length ? filteredGaPropertyId.join(',') : '',
                custom_bq_tool: filteredCustomPropertyId?.length ? filteredCustomPropertyId.join(',') : '',
                chat_id: chatid ? chatid : chatId ? chatId : "",
                workspace_id: getWorkspaceIdFromStorage()
            };

            console.log('🌐 [handleQuestion] Step 10: Payload created:', payload);

            console.log('🚀 [handleQuestion] Step 11: Getting auth token...');
            // Get authentication token (skip for iframe, use static email)
            const isInIframe = window.self !== window.top;
            let authData;

            if (isInIframe) {
                authData = {
                    token: null,
                    tokenType: null,
                    email: 'karan.anand@interactiveavenues.com'
                };
            } else {
                authData = await getAuthToken();
            }


            console.log('🚀 [handleQuestion] Step 12: Calling buildSSEUrl with auth...');
            // Build SSE URL with authentication in URL (EventSource doesn't support headers)
            const sseUrl = buildSSEUrl(payload, authData);

            console.log('🌐 [handleQuestion] SSE URL built:', sseUrl.replace(/token=[^&]+/, 'token=***'));

            console.log('🚀 [handleQuestion] Step 14: Sending ReactGA event...');
            ReactGA.event('chat_started', {
                method: 'live_chat_sse',
                source_page: window.location.pathname,
                message_length: question ? question?.length : 0,
                user_language: 'en',
            });

            console.log('🚀 [handleQuestion] Step 15: Calling startStream...');
            // Start SSE streaming (token in URL)
            startStream(sseUrl, {
                onInit: (initData) => {
                    // Stream initialized with chat_id and message_id
                    console.log('✅ [SSE onInit] Stream initialized:', initData);

                    // Add initial question to data (only once)
                    setData(prev => {
                        const newMessage = {
                            question: question,
                            timestamp: new Date().toISOString(),
                            message_id: initData.message_id,
                            chat_id: initData.chat_id,
                            streaming: true, // Flag to indicate this is being streamed
                            chat: [{
                                agent: 'Assistant',
                                text_response: '', // Will be progressively updated
                                data: {}
                            }]
                        };
                        console.log('✅ [SSE onInit] Adding streaming message to data:', newMessage);
                        console.log('✅ [SSE onInit] Previous data length:', prev.length);
                        const newData = [...prev, newMessage];
                        console.log('✅ [SSE onInit] New data length:', newData.length);
                        return newData;
                    });
                },
                onChunk: (chunkData) => {
                    // Real-time text chunk received - contains FULL accumulated chunk data
                    const chunkText = chunkData?.chat?.[0]?.text_response || chunkData.text || '';
                    console.log('📨 [SSE onChunk] Chunk received:', {
                        hasChat: !!chunkData?.chat,
                        chatLength: chunkData?.chat?.length,
                        textLength: chunkText?.length,
                        fullChunkData: chunkData
                    });

                    // Update data state with FULL chunk data (not just text)
                    setData(prev => {
                        const lastIndex = prev.length - 1;
                        console.log('📨 [SSE onChunk] Checking last message:', {
                            lastIndex,
                            hasMessage: lastIndex >= 0,
                            isStreaming: lastIndex >= 0 ? prev[lastIndex].streaming : null,
                            currentTextLength: lastIndex >= 0 && prev[lastIndex].chat?.[0] ? prev[lastIndex].chat[0].text_response?.length : 0
                        });

                        if (lastIndex >= 0 && prev[lastIndex].streaming) {
                            const updated = [...prev];

                            // Store ENTIRE chunk data, replacing the streaming message
                            // Keep the question and streaming flag from init
                            const question = updated[lastIndex].question;
                            updated[lastIndex] = {
                                ...chunkData,  // Use all chunk data
                                question: question,  // Preserve original question
                                streaming: true  // Keep streaming flag
                            };

                            console.log('📨 [SSE onChunk] Updated data state with full chunk:', {
                                textLength: chunkData?.chat?.[0]?.text_response?.length,
                                hasVisualTag: !!chunkData?.chat?.[0]?.visual_tag,
                                agent: chunkData?.chat?.[0]?.agent,
                                preview: chunkText.substring(0, 100)
                            });

                            return updated;
                        }
                        console.warn('⚠️ [SSE onChunk] No streaming message found to update!');
                        return prev;
                    });
                },
                onComplete: (finalData) => {
                    console.log('✅✅✅ [SSE] Stream completed!');
                    console.log('📦 [SSE] Final data structure:', finalData);
                    console.log('📦 [SSE] Has chat_id?:', !!finalData?.chat_id);
                    console.log('📦 [SSE] Has chat array?:', !!finalData?.chat);
                    console.log('📦 [SSE] Chat length:', finalData?.chat?.length);

                    // Stop polling for status updates
                    setQuestionQuery(true)

                    // Handle system errors
                    if (finalData?.chat?.[0]?.agent === 'System') {
                        console.error('❌ [SSE] System error detected');
                        toast.error(finalData?.chat[0]?.text_response || 'An error occurred', {
                            autoClose: 4000
                        });
                        // Remove the streaming message on error
                        setData(prev => prev.filter(item => !item.streaming));
                        return;
                    }

                    // Update the existing message with complete backend data
                    if (finalData?.chat && finalData.chat.length > 0) {
                        console.log('✅ [SSE] Replacing with complete backend response');
                        setData(prev => {
                            // Find and replace the streaming message
                            const lastIndex = prev.length - 1;
                            if (lastIndex >= 0 && prev[lastIndex].streaming) {
                                const updated = [...prev];

                                // Replace with complete final data from backend
                                // No need to merge chunks - use the complete response as-is
                                updated[lastIndex] = {
                                    ...finalData,
                                    streaming: false, // Mark as complete
                                    justCompleted: true // Flag for animation
                                };

                                console.log('✅ [SSE] Replaced streaming message with final response:', {
                                    finalTextLength: finalData.chat[0]?.text_response?.length,
                                    hasVisualData: !!finalData.chat[0]?.data && Object.keys(finalData.chat[0]?.data || {}).length > 0,
                                    agent: finalData.chat[0]?.agent
                                });

                                return updated;
                            }
                            // Fallback: if not found, append (shouldn't happen)
                            return [...prev, { ...finalData, streaming: false }];
                        });
                    } else {
                        console.warn('⚠️ [SSE] No chat array in response!');
                    }

                    // Update chat ID for future messages
                    if (finalData?.chat_id) {
                        const chat_id = finalData.chat_id;
                        console.log('🔄 [SSE] Setting chat_id:', chat_id);
                        setChatId(chat_id);

                        // Mark that this chatId came from streaming (to avoid redundant API call)
                        chatIdFromStreamingRef.current = true;

                        // Update URL with chatId in search params
                        const currentParams = new URLSearchParams(location.search);
                        if (currentParams.get('chatid') !== chat_id) {
                            currentParams.set('chatid', chat_id);
                            console.log('🔄 [SSE] Updating URL with chatId (from streaming):', chat_id);
                            navigate(`/conversation?${currentParams.toString()}`, { replace: true });
                        }
                    }

                    // Refresh conversation history in sidebar (for left panel)
                    console.log('🔄 [SSE] Calling getConversation...');
                    getConversation();

                    // Update query count in header after successful completion
                    console.log('🔄 [SSE] Invalidating query count to refresh header...');
                    dispatch(baseApi.util.invalidateTags(['currentPlan']));

                    // Auto-scroll to bottom after streaming completes
                    // Only scroll if there's no message_id parameter (user isn't viewing a specific message)
                    const urlParams = new URLSearchParams(location.search);
                    const messageId = urlParams.get('message_id');

                    if (!messageId) {
                        // Multiple scroll attempts to handle progressive rendering of visual elements
                        console.log('📜 [SSE] Auto-scrolling to bottom after completion');
                        setTimeout(() => {
                            bottomScrollRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
                        }, 300);
                        // Second scroll after visual elements have rendered
                        setTimeout(() => {
                            bottomScrollRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
                        }, 800);
                        // Final scroll to ensure we're at the absolute bottom
                        setTimeout(() => {
                            bottomScrollRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
                        }, 1500);
                    } else {
                        console.log('📜 [SSE] Skipping auto-scroll, message_id parameter present:', messageId);
                    }

                    // Handle navigation if needed
                    if (location?.state?.question && location.pathname !== "/conversation") {
                        console.log('[handleQuestion] Navigating due to location.state.question');
                        navigate("/conversation", { replace: true });
                    }
                },
                onError: (err) => {
                    setQuestionQuery(true);

                    // Remove the streaming message from UI
                    setData(prev => prev.filter(item => !item.streaming));

                    // Stop the stream
                    stopStream();

                    // Extract error message from various possible formats
                    let errorMessage = 'Error during streaming. Please try again.';

                    if (err?.type === 'error') {
                        // Handle error type from SSE data - check chat[0].text_response first
                        errorMessage = err?.chat?.[0]?.text_response || err?.message || err?.error || errorMessage;
                    } else if (err?.chat?.[0]?.text_response) {
                        // Check chat array for error message
                        errorMessage = err.chat[0].text_response;
                    } else if (err?.data?.message) {
                        // Handle nested error messages
                        errorMessage = err.data.message;
                    } else if (err?.message) {
                        // Handle standard error message
                        errorMessage = err.message;
                    }

                    if (isOnline) {
                        toast.error(errorMessage);
                    } else {
                        toast.error("Internet Not Connected! Please check your connection.");
                    }
                }
            });

        } catch (error) {
            // Stop polling for status updates on error
            console.error('❌❌❌ [handleQuestion] CAUGHT ERROR:', error);
            console.error('❌❌❌ [handleQuestion] Error stack:', error?.stack);
            setQuestionQuery(true)
            console.error(error);
            if (isOnline) {
                toast.error(error?.data?.error || error?.data?.message || error || 'Unexpected error');
            } else {
                toast.error("Internet Not Connected! Please check your connection.")
            }
        }
    }

    const handleEditQuestion = (question) => {

        // setValue("questionInput", question)
        setEditableQuestion(question?.question); // Set the question to be edited

    }

    const handleClickNewChat = () => {
        console.log('[handleClickNewChat] CALLED - will navigate to clear URL');
        setData([]);
        setValue("questionInput", '');
        setSuggestions([]); // Clear suggestions when starting new chat

        // Always navigate to clean conversation URL, even if already on conversation page
        // This ensures chatId is removed from URL
        console.log('[handleClickNewChat] Navigating to /conversation without chatId');
        navigate("/conversation", { replace: true });

        getConversation();
        setChatId("")
        setUseHistoryToggle(true)
        setHistory(true);

        // Reset preferences loaded flag to allow reloading default values
        preferencesLoadedRef.current = false;

        // Reset tracking refs
        chatIdFromStreamingRef.current = false;
        lastLoadedChatIdRef.current = null;
        pendingChatIdRef.current = null;

        // Reset data source modification flags
        setUserModifiedDataSources(false);
        conversationDataLoadedRef.current = false;

        // Scroll to top of page
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }


    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] property selection sync', {
        //     hasProps: listIntegrationData?.property_ids?.length > 0,
        //     chatId,
        //     historyEnable,
        //     hasDefault: !!defaultPropertiesData
        // });

        if (!(listIntegrationData?.property_ids?.length > 0)) return;

        // Load saved preferences when not viewing a specific chat (run-once guard)
        if (!chatId?.length && !defaultPropertiesLoading) {
            if (!preferencesLoadedRef.current) {
                const workspaceId = localStorage.getItem("workspace_id");
                const localStorageKey = `conversation_accounts_${workspaceId}`;

                // Try localStorage first for faster loading
                let savedPreferences = null;
                try {
                    const localData = localStorage.getItem(localStorageKey);
                    if (localData) savedPreferences = JSON.parse(localData);
                } catch (error) {
                    console.warn("Failed to parse localStorage account preferences:", error);
                }

                // Use backend data if available, otherwise use localStorage
                const backendPreferences = defaultPropertiesData?.property_names;

                if (backendPreferences && backendPreferences.length > 0) {
                    const nextCustom = backendPreferences.filter(i => i.integrationType === 'Custom').map(i => i.propertyId);
                    const nextGa = backendPreferences.filter(i => i.integrationType === 'GA4').map(i => i.propertyId);
                    const nextShopify = backendPreferences.filter(i => i.integrationType === 'Shopify').map(i => i.propertyId);
                    const nextMeta = backendPreferences.filter(i => i.integrationType === 'Meta').map(i => i.propertyId);
                    const nextAds = backendPreferences.filter(i => i.integrationType === 'GoogleAds').map(i => i.propertyId);
                    const nextYouTube = backendPreferences.filter(i => i.integrationType === 'YouTube').map(i => i.propertyId);
                    const nextYouTubeChannel = backendPreferences.filter(i => ['YouTubeChannel', 'YouTubeChannels', 'YoutubeChannel'].includes(i.integrationType)).map(i => i.propertyId);

                    if (!arraysEqual(customPropertyId, nextCustom)) setCustomPropertyId(nextCustom);
                    if (!arraysEqual(gaPropertyId, nextGa)) setGaPropertyId(nextGa);
                    if (!arraysEqual(shopifyPropertyId, nextShopify)) setShopifyPropertyId(nextShopify);
                    if (!arraysEqual(metaPropertyId, nextMeta)) setMetaPropertyId(nextMeta);
                    if (!arraysEqual(adsPropertyId, nextAds)) setAdsPropertyId(nextAds);
                    if (!arraysEqual(youtubePropertyId, nextYouTube)) setYoutubePropertyId(nextYouTube);
                    if (!arraysEqual(youtubeChannelId, nextYouTubeChannel)) setYoutubeChannelId(nextYouTubeChannel);
                } else if (savedPreferences) {
                    const allProperties = listIntegrationData?.property_names || [];
                    const nextCustom = (savedPreferences.customPropertyId || []).filter(id => allProperties.some(p => p.propertyId === id && p.integrationType === 'Custom'));
                    const nextGa = (savedPreferences.gaPropertyId || []).filter(id => allProperties.some(p => p.propertyId === id && p.integrationType === 'GA4'));
                    const nextShopify = (savedPreferences.shopifyPropertyId || []).filter(id => allProperties.some(p => p.propertyId === id && p.integrationType === 'Shopify'));
                    const nextMeta = (savedPreferences.metaPropertyId || []).filter(id => allProperties.some(p => p.propertyId === id && p.integrationType === 'Meta'));
                    const nextAds = (savedPreferences.adsPropertyId || []).filter(id => allProperties.some(p => p.propertyId === id && p.integrationType === 'GoogleAds'));
                    const nextYouTube = (savedPreferences.youtubePropertyId || []).filter(id => allProperties.some(p => p.propertyId === id && p.integrationType === 'YouTube'));
                    const nextYouTubeChannel = (savedPreferences.youtubeChannelId || []).filter(id => allProperties.some(p => p.propertyId === id && ['YouTubeChannel', 'YouTubeChannels', 'YoutubeChannel'].includes(p.integrationType)));

                    if (!arraysEqual(customPropertyId, nextCustom)) setCustomPropertyId(nextCustom);
                    if (!arraysEqual(gaPropertyId, nextGa)) setGaPropertyId(nextGa);
                    if (!arraysEqual(shopifyPropertyId, nextShopify)) setShopifyPropertyId(nextShopify);
                    if (!arraysEqual(metaPropertyId, nextMeta)) setMetaPropertyId(nextMeta);
                    if (!arraysEqual(adsPropertyId, nextAds)) setAdsPropertyId(nextAds);
                    if (!arraysEqual(youtubePropertyId, nextYouTube)) setYoutubePropertyId(nextYouTube);
                    if (!arraysEqual(youtubeChannelId, nextYouTubeChannel)) setYoutubeChannelId(nextYouTubeChannel);
                } else if (!chatId) {
                    // No saved preferences found and no chat ID - select all accounts by default for new conversations only
                    const allProperties = listIntegrationData?.property_names || [];
                    const allCustom = allProperties.filter(i => i.integrationType === 'Custom').map(i => i.propertyId);
                    const allGa = allProperties.filter(i => i.integrationType === 'GA4').map(i => i.propertyId);
                    const allShopify = allProperties.filter(i => i.integrationType === 'Shopify').map(i => i.propertyId);
                    const allMeta = allProperties.filter(i => i.integrationType === 'Meta').map(i => i.propertyId);
                    const allAds = allProperties.filter(i => i.integrationType === 'GoogleAds').map(i => i.propertyId);
                    const allYouTube = allProperties.filter(i => i.integrationType === 'YouTube').map(i => i.propertyId);
                    const allYouTubeChannel = allProperties.filter(i => ['YouTubeChannel', 'YouTubeChannels', 'YoutubeChannel'].includes(i.integrationType)).map(i => i.propertyId);

                    if (!arraysEqual(customPropertyId, allCustom)) setCustomPropertyId(allCustom);
                    if (!arraysEqual(gaPropertyId, allGa)) setGaPropertyId(allGa);
                    if (!arraysEqual(shopifyPropertyId, allShopify)) setShopifyPropertyId(allShopify);
                    if (!arraysEqual(metaPropertyId, allMeta)) setMetaPropertyId(allMeta);
                    if (!arraysEqual(adsPropertyId, allAds)) setAdsPropertyId(allAds);
                    if (!arraysEqual(youtubePropertyId, allYouTube)) setYoutubePropertyId(allYouTube);
                    if (!arraysEqual(youtubeChannelId, allYouTubeChannel)) setYoutubeChannelId(allYouTubeChannel);

                    // Save the default selection (debounced auto-save will handle persistence)
                }

                // mark initialized to avoid re-applying same selections
                preferencesLoadedRef.current = true;
            }
            return; // don't run chatData sync when viewing default state
        }

        // Sync with specific chat history selection when viewing a chat
        // BUT: Don't sync if user modified data sources OR currently streaming (preserves active session selections)
        if (chatData && chatId && !userModifiedDataSources && !isStreaming) {
            // Get the last message from history if available, otherwise use the main chat data
            const lastMessage = chatData?.history && chatData.history.length > 0
                ? chatData.history[chatData.history.length - 1]
                : chatData;

            const nextGa = lastMessage?.property_id ? (Array.isArray(lastMessage.property_id) ? lastMessage.property_id : lastMessage.property_id.split(',').filter(id => id)) : [];
            const nextShopify = lastMessage?.shopify_id ? (Array.isArray(lastMessage.shopify_id) ? lastMessage.shopify_id : lastMessage.shopify_id.split(',').filter(id => id)) : [];
            const nextMeta = lastMessage?.meta_id ? (Array.isArray(lastMessage.meta_id) ? lastMessage.meta_id : lastMessage.meta_id.split(',').filter(id => id)) : [];
            const nextAds = lastMessage?.google_ads_id ? (Array.isArray(lastMessage.google_ads_id) ? lastMessage.google_ads_id : lastMessage.google_ads_id.split(',').filter(id => id)) : [];
            const nextCustom = lastMessage?.custom_bq_tool ? (Array.isArray(lastMessage.custom_bq_tool) ? lastMessage.custom_bq_tool : lastMessage.custom_bq_tool.split(',').filter(id => id)) : [];

            console.log('🔄 [Effect] Syncing data sources from chat history:', {
                nextGa, nextShopify, nextMeta, nextAds, nextCustom
            });

            if (!arraysEqual(gaPropertyId, nextGa)) setGaPropertyId(nextGa);
            if (!arraysEqual(shopifyPropertyId, nextShopify)) setShopifyPropertyId(nextShopify);
            if (!arraysEqual(metaPropertyId, nextMeta)) setMetaPropertyId(nextMeta);
            if (!arraysEqual(adsPropertyId, nextAds)) setAdsPropertyId(nextAds);
            if (!arraysEqual(customPropertyId, nextCustom)) setCustomPropertyId(nextCustom);
        } else if (chatData && chatId) {
            console.log('⚠️ [Effect] NOT syncing data sources because:', {
                userModified: userModifiedDataSources,
                isStreaming: isStreaming,
                reason: userModifiedDataSources ? 'User manually modified data sources' :
                    isStreaming ? 'Currently streaming' : 'Unknown'
            });
        }
    }, [
        chatData?.property_id,
        chatId,
        defaultPropertiesData?.property_names,
        defaultPropertiesLoading,
        listIntegrationData?.property_ids?.length,
        listIntegrationData?.property_names,
        // chatData is intentionally not fully spread to avoid unnecessary triggers
        historyEnable,
        // State values used for equality checks
        gaPropertyId,
        shopifyPropertyId,
        metaPropertyId,
        adsPropertyId,
        customPropertyId,
        arraysEqual,
        userModifiedDataSources,
        isStreaming
    ]);

    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] property IDs changed (debounced refetch guard)', { gaPropertyId, shopifyPropertyId, metaPropertyId, adsPropertyId, chatId });
        // Only refetch when there's no chatId AND we actually have some property changes
        // This prevents excessive refetching on component mount/re-renders
        const hasAnyPropertyId = gaPropertyId?.length || shopifyPropertyId?.length || metaPropertyId?.length || adsPropertyId?.length || youtubePropertyId?.length || youtubeChannelId?.length;

        if (!chatId?.length && hasAnyPropertyId) {
            const timeoutId = setTimeout(() => {
                // No need to refetch since localStorage is synchronous
            }, 300); // Debounce for 300ms

            return () => clearTimeout(timeoutId);
        };
    }, [gaPropertyId, shopifyPropertyId, metaPropertyId, adsPropertyId, chatId]);

    // Safety check: Ensure data sources are never empty in new conversations
    useEffect(() => {
        if (!chatId?.length && listIntegrationData?.property_ids?.length > 0) {
            const totalSelectedCount = customPropertyId.length + gaPropertyId.length + shopifyPropertyId.length + metaPropertyId.length + adsPropertyId.length + youtubePropertyId.length + youtubeChannelId.length;

            // If no data sources are selected in a new conversation, auto-select all available
            if (totalSelectedCount === 0) {
                const allPropertyNames = listIntegrationData?.property_names || [];

                const autoCustomPropertyIds = allPropertyNames
                    .filter((item) => item.integrationType === "Custom")
                    .map((item) => item.propertyId);

                const autoGaPropertyIds = allPropertyNames
                    .filter((item) => item.integrationType === "GA4")
                    .map((item) => item.propertyId);

                const autoShopifyPropertyIds = allPropertyNames
                    .filter((item) => item.integrationType === "Shopify")
                    .map((item) => item.propertyId);

                const autoMetaPropertyIds = allPropertyNames
                    .filter((item) => item.integrationType === "Meta")
                    .map((item) => item.propertyId);

                const autoAdsPropertyIds = allPropertyNames
                    .filter((item) => item.integrationType === "GoogleAds")
                    .map((item) => item.propertyId);

                // Set all available data sources as selected
                setCustomPropertyId(autoCustomPropertyIds);
                setGaPropertyId(autoGaPropertyIds);
                setShopifyPropertyId(autoShopifyPropertyIds);
                setMetaPropertyId(autoMetaPropertyIds);
                setAdsPropertyId(autoAdsPropertyIds);
            }
        }
    }, [chatId, customPropertyId, gaPropertyId, shopifyPropertyId, metaPropertyId, adsPropertyId, listIntegrationData]);

    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] isPropertyIdClear toggled', { isClearPropertyId });

        // Check if we're loading a specific chat
        const urlParams = new URLSearchParams(location.search);
        const chatIdFromUrl = urlParams.get('chatid');
        const isLoadingSpecificChat = sessionStorage.getItem('isLoadingSpecificChat') === 'true';

        // console.log('[Effect] isPropertyIdClear - chatIdFromUrl:', chatIdFromUrl, 'isLoadingSpecificChat:', isLoadingSpecificChat);

        if (isClearPropertyId) {
            setValue("property_id", []);
            setAdsPropertyId([]);
            setGaPropertyId([]);
            setMetaPropertyId([]);
            setShopifyPropertyId([]);
            setCustomPropertyId([]);
            setYoutubePropertyId([]);
            setYoutubeChannelId([]);
            dispatch(isPropertyIdClear(false));

            // Don't start a new chat if we're trying to load a specific chat
            if (!chatIdFromUrl && !chatId && !isLoadingSpecificChat) {
                // console.log('[Effect] isPropertyIdClear - calling handleClickNewChat');
                handleClickNewChat();
            } else {
                // console.log('[Effect] isPropertyIdClear - SKIPPING handleClickNewChat because we have a chatId');
            }
        }
    }, [isClearPropertyId, location.search, chatId]);

    // Auto-save when properties change (but not on initial load or when viewing chat)
    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] auto-save properties (debounced)', { customPropertyId, gaPropertyId, shopifyPropertyId, metaPropertyId, adsPropertyId, chatId, hasProps: listIntegrationData?.property_ids?.length });
        const hasProperties = customPropertyId?.length || gaPropertyId?.length || shopifyPropertyId?.length || metaPropertyId?.length || adsPropertyId?.length || youtubePropertyId?.length || youtubeChannelId?.length;

        if (!chatId?.length && hasProperties && listIntegrationData?.property_ids?.length > 0) {
            // Debounce the save operation
            const saveTimeout = setTimeout(() => {
                handleSaveDefaultProperties();
            }, 1000); // Wait 1 second after user stops making changes

            return () => clearTimeout(saveTimeout);
        }
    }, [customPropertyId, gaPropertyId, shopifyPropertyId, metaPropertyId, adsPropertyId, youtubePropertyId, youtubeChannelId, chatId, listIntegrationData?.property_ids?.length]);

    const handleUpdateHistory = (checked, chatIdParam) => {
        if (chatId || chatIdParam) {
            const payloadHistory = {
                use_history_chat_or_not: checked,
                chat_id: chatId || chatIdParam
            }
            updateHistory(payloadHistory)
                .unwrap()
                .then((response) => {
                })
                .catch((error) => {

                })
        }
    }

    const handleOpenThumbsUp = (status, time, method, comment) => {
        setThumbsAction({
            ...thumbsAction,
            comment: method === "edit" ? comment : "",
            open: true,
            status: status,
            time: time,
            method: method
        });
    }

    const handleUpdatethumbsUpStatus = () => {
        if (thumbsAction?.method === 'edit') {
            const payload = {
                chat_id: chatId,
                chat_timestamp: thumbsAction?.time,
                comment: thumbsAction?.comment,
                thumbs: thumbsAction?.status,
            }
            updateComments(payload)
                .unwrap()
                .then((response) => {
                    if (response) {
                        const eventName = thumbsAction?.status === 'up' ? 'response_liked' : 'response_disliked';
                        ReactGA.event(eventName, {
                            action: 'edit',
                            has_comment: !!thumbsAction?.comment,
                            chat_id: chatId,
                        });

                        getChatHistory(chatId)
                            .unwrap()
                            .then((historyResponse) => {
                                if (historyResponse?.history) {
                                    setData(historyResponse.history);
                                }
                            })
                            .catch((error) => {
                                console.error('Failed to refresh chat history:', error);
                            });

                        setThumbsAction(
                            {
                                open: false,
                                status: null,
                                time: null,
                                comment: "",
                                method: "add"
                            }
                        )
                    }
                })
                .catch((error) => {
                    ReactGA.event('feedback_error', {
                        feedback_type: thumbsAction?.status === 'up' ? 'thumbs_up' : 'thumbs_down',
                        action: 'edit',
                        error_message: error?.data?.message || 'Unknown error',
                    });
                })
        } else {
            const payload = {
                chat_id: chatId,
                chat_timestamp: thumbsAction?.time,
                thumbs: thumbsAction?.status,
                comment: thumbsAction?.comment
            }
            thumbsUpStatus(payload)
                .unwrap()
                .then((response) => {
                    if (response) {
                        const eventName = thumbsAction?.status === 'up' ? 'response_liked' : 'response_disliked';
                        ReactGA.event(eventName, {
                            action: 'new',
                            has_comment: !!thumbsAction?.comment,
                            chat_id: chatId,
                        });

                        getChatHistory(chatId)
                            .unwrap()
                            .then((historyResponse) => {
                                if (historyResponse?.history) {
                                    setData(historyResponse.history);
                                }
                            })
                            .catch((error) => {
                                console.error('Failed to refresh chat history:', error);
                            });

                        setThumbsAction(
                            {
                                open: false,
                                status: null,
                                time: null,
                                comment: "",
                                method: "add"
                            }
                        )
                    }
                })
                .catch((error) => {
                    ReactGA.event('feedback_error', {
                        feedback_type: thumbsAction?.status === 'up' ? 'thumbs_up' : 'thumbs_down',
                        action: 'new',
                        error_message: error?.data?.message || 'Unknown error',
                    });
                })

        }

    }

    const handleSaveEdit = () => {
        setEditableQuestion(null);
        setEditQuestion(null)
        let payload = {
            chat_id: chatId,
            chat_timestamp: pinnedChat?.timestamp
        }
        editQuestionQyery(payload)
            .unwrap()
            .then((response) => {
                if (response) {
                    handleQuestion(editableQuestion, null)
                }
            })
            .catch((error) => {

            })
    };

    // Auto-scroll to new messages when data changes
    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] data length changed (auto-scroll)', { len: data?.length });
        // Only scroll to bottom if there's no message_id parameter
        const urlParams = new URLSearchParams(location.search);
        const messageId = urlParams.get('message_id');
        if (data?.length > 0 && !messageId) {
            setTimeout(() => {
                chatMessagesRef.current?.lastElementChild?.scrollIntoView({ behavior: "smooth" })
            }, 100)
        }
    }, [data?.length, location.search]);

    const handleEditChat = (data) => {
        const reqmodel = { ...data };
        updateChatName(reqmodel)
            .unwrap()
            .then((response) => {
                if (response) {
                    toast.success(response?.message || "Chat name updated successfully");
                    closeEditChatModal();
                }
            })
            .catch((error) => {
                toast.error(error?.data?.error || error || 'Unexpected error');

            })
    }

    const handleDeleteChat = () => {
        let payload = {
            chat_id: deleteChatId
        }
        deleteChatHistory(payload)
            .unwrap()
            .then((response) => {
                if (response) {
                    toast.success(response?.message || "Chat deleted successfully");
                    closeEditChatModal();
                    handleClickNewChat();
                    closeDeleteChatModal();
                }
            })
            .catch((error) => {
                toast.error(error?.data?.error || error || 'Unexpected error');

            })
    }

    const [showError, setShowError] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] error visibility toggle', { isChatHistoryError, chatData, chatId, isChatHistoryLoading, isStreaming, dataLength: data.length });

        // Don't show error for new chats (when chatId is empty/null)
        if (!chatId) {
            setShowError(false);
            return;
        }

        // Hide error when streaming is active or when conversation data is being displayed
        // This prevents the brief "Something went wrong" flash when starting a new chat while processing
        if (isStreaming || data.length > 0) {
            setShowError(false);
            return;
        }

        // Show error if there's an API error while loading an existing chat
        if (isChatHistoryError && !isChatHistoryLoading) {
            setShowError(true);
        }
        // Show error if existing chat has empty history array
        else if (chatData && chatData.history && Array.isArray(chatData.history) && chatData.history.length === 0) {
            setShowError(true);
        }
        // Hide error if we have valid data with non-empty history
        else if (chatData && chatData.history && chatData.history.length > 0) {
            setShowError(false);
        }
    }, [isChatHistoryError, chatData, chatId, isChatHistoryLoading, isStreaming, data.length]);

    useEffect(() => {
        // eslint-disable-next-line no-console
        // console.log('[Effect] reset visibility on new chat', { newConversation });
        if (newConversation) {
            setShowError(false); // hide error on new chat - no error expected for new conversations
        }
    }, [newConversation]);

    const handleCreateDashboard = async () => {
        try {
            const dashboardName = dashboardMethods.getValues('dashboard_name');
            if (!dashboardName) {
                toast.error('Please enter a dashboard name');
                return;
            }

            const response = await createDashboard({ dashboard_name: dashboardName }).unwrap();

            if (response.message) {
                toast.success('Dashboard created successfully');
                dispatch(createDashboardName(dashboardName));
                dashboardMethods.setValue('dashboard_name', '');
            }
        } catch (error) {
            console.error('Error creating dashboard:', error);
            toast.error(error.data?.error || 'Failed to create dashboard');
        }
    };

    return (
        <>
            {/* Visual iframe detector - uncomment to debug iframe detection */}
            {/* <IframeDetector /> */}

            <div className='conversation_sidebar_master'>
                <div className={chatId ? "h-[calc(81.5vh)]" : ''}>
                    <div ref={chatRef} className="relative">
                        <div className="sticky flex items-center justify-center md:justify-end top-[4rem] z-20 bg-white py-2 pr-2 md:pr-[8px]">
                            <div className="flex gap-2 items-center">
                                <div data-tour="data-sources">
                                    <IntegrationPropertySelector
                                        key={workspaceObjectId}
                                        newChat={chatId ? false : true}
                                        listIntegrationData={listIntegrationData}
                                        listAnalyticsLoading={listAnalyticsLoading}
                                        customBigQueryConversationDropdownLoading={customBigQueryConversationDropdownLoading}
                                        conversationPropertyIds={chatId && chatData?.history?.length > 0 ? {
                                            gaIds: gaPropertyId,
                                            shopifyIds: shopifyPropertyId,
                                            metaIds: metaPropertyId,
                                            adsIds: adsPropertyId,
                                            customIds: customPropertyId,
                                            youtubeIds: youtubePropertyId,
                                            youtubeChannelIds: youtubeChannelId
                                        } : null}
                                        selectedIds={[
                                            ...customPropertyId,
                                            ...gaPropertyId,
                                            ...shopifyPropertyId,
                                            ...metaPropertyId,
                                            ...adsPropertyId,
                                            ...youtubePropertyId,
                                            ...youtubeChannelId
                                        ]}
                                        setSelectedIds={(selected) => {
                                            setHistoryEnable(false);
                                            setUserModifiedDataSources(true); // Mark that user manually changed data sources
                                            // You must break selected into individual types
                                            // Keep existing values and add new ones - defensive filtering
                                            const newCustomIds = selected.filter(id =>
                                                listCustomIntegrationData?.property_names?.find(
                                                    (p) => p.propertyId === id && p.integrationType === "Custom"
                                                )
                                            );
                                            setCustomPropertyId(prev => {
                                                const combined = [...new Set([...prev, ...newCustomIds])];
                                                return combined.filter(id => selected.includes(id));
                                            });

                                            const newGaIds = selected.filter(id =>
                                                listAnalyticsData?.property_names?.find(
                                                    (p) => p.propertyId === id && p.integrationType === "GA4"
                                                )
                                            );
                                            setGaPropertyId(prev => {
                                                const combined = [...new Set([...prev, ...newGaIds])];
                                                return combined.filter(id => selected.includes(id));
                                            });

                                            const newShopifyIds = selected.filter(id =>
                                                listAnalyticsData?.property_names?.find(
                                                    (p) => p.propertyId === id && p.integrationType === "Shopify"
                                                )
                                            );
                                            setShopifyPropertyId(prev => {
                                                const combined = [...new Set([...prev, ...newShopifyIds])];
                                                return combined.filter(id => selected.includes(id));
                                            });

                                            const newMetaIds = selected.filter(id =>
                                                listAnalyticsData?.property_names?.find(
                                                    (p) => p.propertyId === id && p.integrationType === "Meta"
                                                )
                                            );
                                            setMetaPropertyId(prev => {
                                                const combined = [...new Set([...prev, ...newMetaIds])];
                                                return combined.filter(id => selected.includes(id));
                                            });

                                            const newAdsIds = selected.filter(id =>
                                                listAnalyticsData?.property_names?.find(
                                                    (p) => p.propertyId === id && p.integrationType === "GoogleAds"
                                                )
                                            );
                                            setAdsPropertyId(prev => {
                                                const combined = [...new Set([...prev, ...newAdsIds])];
                                                return combined.filter(id => selected.includes(id));
                                            });
                                        }}
                                        handleSaveDefaultProperties={handleSaveDefaultProperties}
                                        setSearchQuery={(value) => {
                                            setSearchQuery(value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Chat Messages */}
                        <div
                            ref={chatMessagesRef}
                            className={`bg-white flex flex-col overflow-hidden transition-all ${chatId ? 'pb-[120px]' : ''}`}
                        >
                            {data?.filter(response => !response.streaming).map((response, index) => {
                                return (
                                    <div
                                        className="overflow-y-auto overflow-x-hidden p-4 space-y-4"
                                        key={index}
                                        id={`chat-${response.message_id || response.created_at || response.timestamp || index}`}
                                        ref={bottomScrollRef}>
                                        <div className="flex justify-end gap-2">
                                            {editQuestion === index ? (
                                                // Render input field if the question is being edited
                                                <form
                                                    onSubmit={(e) => {
                                                        e.preventDefault(); // Prevent page reload
                                                        handleSaveEdit(); // Function to handle the save
                                                    }}
                                                    className="flex flex-col gap-2 w-[50%]  rounded-lg "
                                                >
                                                    <textarea
                                                        disabled={isLoading}
                                                        value={editableQuestion}
                                                        onChange={(e) => setEditableQuestion(e.target.value)}
                                                        className="resize-none bg-white rounded-[20px] w-full p-2.5 tracking-tight leading-5 font-normal text-[#181D27] shadow-sm focus:outline-none"
                                                        style={{ borderWidth: '1px', borderStyle: 'solid', borderColor: isInIframe ? '#0086C9' : '#26BF77' }}
                                                        placeholder="Edit your message..."
                                                        rows={4} // Set the number of rows
                                                    />
                                                    <div className="flex justify-end gap-2">
                                                        <Button
                                                            htmlType="submit"
                                                            type="primary"
                                                            disabled={isLoading}
                                                        >
                                                            Save
                                                        </Button>
                                                        <Button
                                                            type="default"
                                                            disabled={isLoading}
                                                            onClick={() => setEditQuestion(null)} // Cancel Editing
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </div>
                                                </form>

                                            ) : (
                                                <div className='flex gap-1 group'>
                                                    <Button
                                                        shape="circle"
                                                        type="default"
                                                        size='small'
                                                        className='bg-[#F7F7F7] shadow-none invisible group-hover:visible'
                                                        onClick={() => {
                                                            handleEditQuestion(response);
                                                            setEditQuestion(index);
                                                            setPinnedChat(response)
                                                        }}
                                                        icon={<EditChatIcon />}
                                                    />
                                                    <div className="bg-[#0A0D120D] px-3 py-2 font-normal border border-[#D5D7DA] rounded-[16px] text-[#181D27] text-sm shadow-sm">
                                                        {response?.question}
                                                    </div>
                                                    {/* <LoginUser className="h-[40px] w-[40px]" /> */}
                                                </div>
                                            )}
                                        </div>

                                        <div className="flex gap-4">
                                            <div className="hidden md:block">
                                                <div className={`h-[24px] w-[24px] mt-3 ${statusLoading ? "animate-pulse" : ""}`}>
                                                    {isInIframe ? (
                                                        <AskAILogo className='h-[24px] w-[24px]' />
                                                    ) : (
                                                        <OogwaiLogo3 className='h-[24px] w-[24px]' />
                                                    )}
                                                </div>
                                            </div>
                                            <div className='w-full overflow-x-hidden'>
                                                <div className={response?.justCompleted ? 'animate-fadeIn' : ''}>
                                                    {handleVisualTag(response)}
                                                </div>
                                                <p className='font-normal text-xs text-text-600 text-end'>{response?.timestamp ? `${new Date(response?.timestamp).toLocaleDateString()} ${new Date(response?.timestamp).toLocaleTimeString("en-US")}` : ''}</p>

                                                <div className="flex gap-1 border-t border-gray-300 pt-2">
                                                    {response?.chat && response?.chat[0]?.agent !== 'System' && !response?.streaming && (
                                                        <>
                                                            <Button
                                                                type="text"
                                                                id={response?.thumbsUp ? "like_key_active" : "like_key"}
                                                                icon={response?.thumbsUp ? <LikeButtonActiveIcon className="h-[30px] w-[30px]" /> : <ThumbsUpIcon className="h-[18px] w-[18px]" />}
                                                                onClick={() => response?.thumbsUp ? handleOpenThumbsUp('1', response?.timestamp, "edit", response?.comment) : handleOpenThumbsUp('1', response?.timestamp, "add", response?.comment)}
                                                            />

                                                            <Button
                                                                type="text"
                                                                id={response?.thumbsDown ? "dis_like_key_active" : 'dis_like_key'}
                                                                icon={response?.thumbsDown ? <DisLikeButtonActiveIcon className="h-[30px] w-[30px]" /> : <ThumbsDownIcon className="h-[18px] w-[18px]" />}
                                                                onClick={() => response?.thumbsDown ? handleOpenThumbsUp('0', response?.timestamp, "edit", response?.comment) : handleOpenThumbsUp('0', response?.timestamp, "add", response?.comment)}
                                                            />


                                                            <Button
                                                                type="text"
                                                                onClick={() => {
                                                                    ReactGA.event('response_regenerated', {
                                                                        chat_id: chatId,
                                                                        question: response?.question,
                                                                        timestamp: response?.timestamp,
                                                                    });
                                                                    setValue("questionInput", response?.question ?? '');
                                                                    handleQuestion(response?.question, null);
                                                                }}
                                                                disabled={isLoading}
                                                                icon={<RegenerateChatIcon className="h-[20px] w-auto" />}
                                                            />
                                                            <Button
                                                                type="text"
                                                                shape="circle"
                                                                className={response?.bookmark_status ? 'bg-[#EAFAF2] text-[#1F7A50] shadow-none' : 'text-[#414651]'}
                                                                onClick={() => {
                                                                    const eventName = response?.bookmark_status ? 'response_unpinned' : 'response_pinned';
                                                                    ReactGA.event(eventName, {
                                                                        chat_id: chatId,
                                                                        question: response?.question,
                                                                        timestamp: response?.timestamp,
                                                                    });
                                                                    response?.bookmark_status ? deleteBookmarkFn(response) : handleBookmark(response);
                                                                }}
                                                                // loading={isLoading}
                                                                icon={<PinChatIcon className="h-[20px] w-auto" />}
                                                            />
                                                            {/* <Button
                                                        type="text"
                                                        // onClick={handleBookmark}
                                                        // loading={isQuestionLoading}
                                                        icon={<DownloadConversationIcon className="h-[20px] w-auto" />}
                                                    /> */}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )
                            })}

                            {/* Streaming Response with Typewriter Effect - Show when streaming is active */}
                            {(() => {
                                // Show streaming UI when: streaming with data, OR streaming without data (initializing/transitioning)
                                const shouldShowStreaming = isStreaming && (data.length === 0 || data[data.length - 1]?.streaming);
                                const streamingMessage = data.length > 0 ? data[data.length - 1] : null;
                                const chunkText = streamingMessage?.chat?.[0]?.text_response || currentChunk || '';

                                // console.log('🎬 [Streaming UI Check]', {
                                //     isStreaming,
                                //     dataLength: data.length,
                                //     lastMessageStreaming: streamingMessage?.streaming,
                                //     shouldShowStreaming,
                                //     currentChunkExists: !!currentChunk,
                                //     currentChunkLength: currentChunk?.length,
                                //     dataChunkExists: !!streamingMessage?.chat?.[0]?.text_response,
                                //     dataChunkLength: streamingMessage?.chat?.[0]?.text_response?.length,
                                //     usingText: chunkText.length > 0 ? 'data state' : 'none'
                                // });
                                return shouldShowStreaming;
                            })() && (() => {
                                const streamingMessage = data.length > 0 ? data[data.length - 1] : null;
                                const chunkText = streamingMessage?.chat?.[0]?.text_response || currentChunk || '';

                                return (
                                    <div className="overflow-y-auto overflow-x-hidden p-4 space-y-4">
                                        {/* Question - only show if we have a streaming message */}
                                        {streamingMessage?.question && (
                                            <div className="flex justify-end gap-2">
                                                <div className="bg-[#0A0D120D] px-3 py-2 font-normal border border-[#D5D7DA] rounded-[16px] text-[#181D27] text-sm shadow-sm">
                                                    {streamingMessage.question}
                                                </div>
                                            </div>
                                        )}

                                        {/* Answer with Typewriter */}
                                        <div className="flex gap-4">
                                            <div className="hidden md:block">
                                                <div className="h-[24px] w-[24px] mt-3 animate-pulse">
                                                    {isInIframe ? (
                                                        <AskAILogo className='h-[24px] w-[24px]' />
                                                    ) : (
                                                        <OogwaiLogo3 className='h-[24px] w-[24px]' />
                                                    )}
                                                </div>
                                            </div>
                                            <div className='w-full overflow-x-hidden'>
                                                {chunkText ? (
                                                    <>
                                                        <div className=" px-4 py-3 ">
                                                            <div className="prose max-w-none">
                                                                <StreamingText
                                                                    text={chunkText}
                                                                    speed={100}
                                                                    isStreaming={isStreaming}
                                                                />
                                                            </div>
                                                        </div>
                                                        <p className='font-normal text-xs text-text-600 text-end mt-1'>Streaming...</p>
                                                    </>
                                                ) : (
                                                    // <div className="bg-[#F7F9FC] px-4 py-3 rounded-lg border border-[#E4E7EC]">
                                                    //     <div className="flex items-center gap-2">
                                                    //         <div className="flex gap-1">
                                                    //             <span className="w-2 h-2 bg-[#279964] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
                                                    //             <span className="w-2 h-2 bg-[#279964] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
                                                    //             <span className="w-2 h-2 bg-[#279964] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
                                                    //         </div>
                                                    //         <p className="text-[#535862] text-sm">Waiting for response...</p>
                                                    //     </div>
                                                    // </div>
                                                    <div className="px-2 py-4">
                                                        <div className="flex items-center gap-2">
                                                            <div className="flex gap-1">
                                                                <span className="w-2 h-2 bg-[#279964] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
                                                                <span className="w-2 h-2 bg-[#279964] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
                                                                <span className="w-2 h-2 bg-[#279964] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                        {/* Chat Input */}
                        <div
                            ref={chatInputRef}
                            className={chatId ? "fixed z-10 bottom-0 widthWebkit " : "relative top-[2rem]"}
                        >
                            {showError && (
                                <ErrorComponent
                                    onClose={() => setShowError(false)}
                                    onTryNewQuery={handleClickNewChat}
                                />
                            )}
                            <div className={chatId ? "bg-[#FAFAFA] containerAnimate border-t  w-[100%]" : ""}>
                                <div className={chatId ? "p-4 flex justify-center items-center" : "mx-auto p-4 "}>
                                    {!chatId && <div className='flex flex-col items-center mb-3'>
                                        {
                                            isInIframe ? <AskAILogo className="min-w-12 h-12" /> : <OogwaiLogo3 className="min-w-12 h-12" />
                                        }
                                        <p className='text-[#414651] text-sm'>{isInIframe ? 'Ask AI' : 'Ask Oogwai'}</p>
                                    </div>}

                                    {/* Polling status indicator */}
                                    {!questionQuery && (
                                        <div className="flex justify-center mb-2">
                                            <span className="text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
                                                🔄 Getting results...
                                            </span>
                                        </div>
                                    )}

                                    <div className="flex justify-center gap-1 w-[100%] max-w-[524px] mx-auto" data-tour="chat-input">
                                        <InputField
                                            name="questionInput"
                                            hint={!questionQuery ? `${currentQueryStatus?.data?.status || " "}...` : suggestionLoading ? "generating suggestions..." : "e.g., ask about audience numbers, conversion rate, bounce rate, sales, etc."}
                                            placeholder={"ask something"}
                                            control={control}
                                            iconDirection={"right"}
                                            customLoadingIcon={<AnimatedSVG />}
                                            disabled={isLoading}
                                            isLoading={isLoading}
                                            onKeyPress={(event) => {
                                                if (!gaPropertyId.length && !shopifyPropertyId.length && !metaPropertyId.length && !adsPropertyId.length && !customPropertyId.length && !youtubePropertyId.length && !youtubeChannelId.length) {
                                                    toast.warning("3. Please select the data source", { toastId: 'default-properties-saved' });
                                                    return;
                                                } else {
                                                    if (event.key === 'Enter') {
                                                        handleQuestion(null, null);
                                                    }
                                                }
                                            }}
                                            onChange={(e) => {
                                                if (gaPropertyId.length < 1 && shopifyPropertyId.length < 1 && metaPropertyId.length < 1 && adsPropertyId.length < 1 && customPropertyId.length < 1 && youtubePropertyId.length < 1 && youtubeChannelId.length < 1) {
                                                    toast.warning("4. Please select the data source", { toastId: 'default-properties-saved' });
                                                    return;
                                                }
                                                if (!chatId) {
                                                    onChangeDebounced(e.target.value);
                                                }
                                            }}
                                        />
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                if (gaPropertyId.length < 1 && shopifyPropertyId.length < 1 && metaPropertyId.length < 1 && adsPropertyId.length < 1 && customPropertyId.length < 1 && youtubePropertyId.length < 1 && youtubeChannelId.length < 1) {
                                                    toast.warning("5. Please select the data source", { toastId: 'select-property' });
                                                    return;
                                                }
                                                // Only check GA connection status if GA properties are selected
                                                if (gaPropertyId.length > 0 && !getStatus?.googleanalytics) {
                                                    toast.error("Google Analytics is not connected yet. Please connect it to ask questions.", { toastId: 'ga-not-connected' });
                                                    return;
                                                } else {
                                                    handleQuestion(null, null)
                                                }
                                            }
                                            }
                                            className="h-11 min-w-11"
                                            loading={isLoading}
                                            icon={<RightArrowIcon />}
                                        />
                                    </div>
                                    {!chatId && !isLoading && <div>
                                        {/* Loading Suggestions */}
                                        <div ref={suggestionRef} className="overflow-hidden">
                                            {suggestionLoading && (
                                                <div className="flex justify-between gap-2 w-[50%] mx-auto">
                                                    <AnimatedSVG />
                                                </div>
                                            )}
                                        </div>

                                        {/* Suggestions */}
                                        <div>
                                            {suggestions?.length > 0 && (
                                                <div className="overflow-hidden w-full pb-2" data-tour="suggested-questions">
                                                    <PromptSuggestions
                                                        className="w-full"
                                                        promptData={suggestions}
                                                        sendPromtApi={(prompt) => {
                                                            setValue("questionInput", prompt);
                                                            setSuggestions([]);
                                                            handleQuestion(prompt, null);
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Onboarding Tour - disabled in iframe */}
            {!isInIframe && (
                <OnboardingTour
                    isOpen={runTour}
                    tourData={currentTour}
                    onComplete={closeTour}
                    onSkip={skipTour}
                />
            )}

            {
                isBookmarkOpen && (
                    <Modal
                        onClose={() => {
                            closeBookmarkModal();
                        }}
                        className="xl:max-w-[60%] lg:max-w-[70%] md:max-w-[75%]"
                    >
                        <div onClick={(e) => e.stopPropagation()} className="">
                            <div className="flex flex-row items-start gap-5">
                                <IconRings numRings={5} ringBaseSize={48} ringSpacing={56} className=" -z-10">
                                    <div className="bg-[#DCFAE6] p-3 w-fit h-fit rounded-full">
                                        <BookmarkIcon className="text-[#17B26A] w-5 h-5" />
                                    </div>
                                </IconRings>
                            </div>
                            <div className="z-10 pt-2">
                                <h4 className=" text-nowrap">What do you want to bookmark?</h4>
                                <p className="text-sm">Select all the stuff you’d want to show up on your daily dashboard</p>
                            </div>
                            <div className='mt-2'>
                                <InputField
                                    control={control}
                                    label={'Bookmark Label'}
                                    placeholder={'Enter your bookmark label'}
                                    type='text'
                                    name="custom_name"
                                />
                            </div>

                            <div className='mt-2 flex flex-col'>
                                <span className="text-[#535862] text-sm font-medium mb-1">Dashboard Name</span>
                                <Select
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    value={dashboardName}
                                    className="min-w-32 propertyId-select"
                                    allowClear
                                    onChange={(value) => {
                                        setValue('dashboard_name', value, { shouldValidate: true });
                                    }}
                                    placeholder="Select Dashboard"
                                    showSearch
                                    dropdownStyle={{ maxHeight: 300, overflowY: 'auto' }}
                                    dropdownRender={(menu) => (
                                        <>
                                            <div style={{ maxHeight: 150, overflowY: 'auto' }}>
                                                {menu}
                                            </div>
                                            <Divider style={{ margin: '8px 0' }} />
                                            <div style={{ padding: '8px' }}>
                                                <p className='text-[#000000] font-normal text-xs'>Add New Dashboard</p>

                                                <div className='mt-3 flex gap-2 items-center'>
                                                    <InputField
                                                        // label="Enter a name for your new dashboard"
                                                        name="dashboard_name"
                                                        control={dashboardMethods.control}
                                                        placeholder="Dashboard Name"
                                                    />
                                                    <Button
                                                        color="primary" variant="outlined"
                                                        loading={isCreateDashboardLoading}
                                                        onClick={(e) => {
                                                            handleCreateDashboard();
                                                        }}
                                                    >
                                                        <GreenRight />
                                                    </Button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                >
                                    {dashboardNamesData?.dashboard_names?.map((item, index) => (
                                        <Option value={item} key={index}>
                                            {item}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            {/* <div className='flex flex-col gap-4 pt-6'>
                                <ToggleButton control={control} label={'Include Trend'} name={'trend'} description='This will include the report for last 15 days from today.' />
                            </div> */}
                            {watch('trend') && (
                                <div className='py-3'>
                                    <PillsBadge rounded name='frequency' control={control} type='tabs' title={[
                                        { label: 'Weekly', value: 'weekly' },
                                        { label: '15 Days', value: '15days' },
                                        { label: 'Monthly', value: 'monthly' },
                                    ]} />
                                </div>
                            )}
                            <div className="flex items-center gap-3 pt-5">
                                <Button
                                    className='w-full'
                                    variant="outlined"
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent backdrop closure
                                        closeBookmarkModal();
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className='w-full'
                                    type="primary"
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent backdrop closure
                                        handleSaveBookmark();
                                    }}
                                >
                                    Confirm
                                </Button>
                            </div>
                        </div>
                    </Modal>
                )
            }



            {
                isEditChatOpen && (
                    <Modal
                        onClose={() => {
                            closeEditChatModal();
                        }}
                        className="xl:max-w-[60%] lg:max-w-[70%] md:max-w-[75%]"
                    >
                        <div onClick={(e) => e.stopPropagation()} className="">
                            <div className="flex flex-row items-start gap-5">
                                <IconRings numRings={5} ringBaseSize={48} ringSpacing={56} className=" -z-10">
                                    <div className="bg-[#DCFAE6] p-3 w-fit h-fit rounded-full">
                                        <BookmarkIcon className="text-[#17B26A] w-5 h-5" />
                                    </div>
                                </IconRings>
                            </div>
                            <div className="z-10 pt-2">
                                <h4 className=" text-nowrap">Edit Title</h4>
                                <p className="text-sm">Change the name of your chat to something you can remember</p>
                            </div>
                            <form onSubmit={handleSubmit(handleEditChat)}>
                                <div className='mt-4'>
                                    <InputField
                                        control={newChatControl}
                                        label={''}
                                        placeholder={'Edit Title'}
                                        type='text'
                                        name="new_chat_name"
                                        rules={{
                                            required: 'Custom Name is required',
                                            ...validationConstants.spaceNotAllows
                                        }}
                                        error={errors.new_chat_name}
                                    />
                                </div>

                                <div className="flex items-center gap-3 pt-5 mt-5">
                                    <Button
                                        className='w-full border border-[#FDA29B!important] text-[#B42318!important] font_weight_600'
                                        variant="outlined"
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent backdrop closure
                                            // handleDeleteChat();
                                            openDeleteChatModal();
                                        }}
                                        icon={<DeleteRedIcon />}
                                    >
                                        Delete Chat
                                    </Button>
                                    <button type='submit' className='font_weight_600 ant-btn ant-btn-primary ant-btn-color-primary ant-btn-variant-solid w-full h-11 p-[0px!important]'>Confirm</button>
                                </div>
                            </form>
                        </div>
                    </Modal>
                )
            }



            {
                isDeleteChatOpen && (
                    <Modal
                        onClose={() => {
                            closeDeleteChatModal();
                        }}
                        className="xl:max-w-[60%] lg:max-w-[70%] md:max-w-[75%]"
                    >
                        <div onClick={(e) => e.stopPropagation()} className="">
                            <div className="flex flex-row items-start gap-5">
                                <IconRings numRings={5} ringBaseSize={48} ringSpacing={56} className=" -z-10">
                                    <div className="bg-[#DCFAE6] p-3 w-fit h-fit rounded-full">
                                        <BookmarkIcon className="text-[#17B26A] w-5 h-5" />
                                    </div>
                                </IconRings>
                            </div>
                            <div className="z-10 pt-2">
                                <h4 className=" text-nowrap">Delete Conversation</h4>
                                <p className="text-sm">Are you sure want to delete this Conversation ?. <br /> {bookmarked && " This conversation is added to bookmarked"} </p>
                            </div>
                            <div className="flex items-center gap-3 pt-5 mt-5">
                                <Button
                                    className='w-full border border-[#FDA29B!important] text-[#B42318!important] font_weight_600'
                                    variant="outlined"
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent backdrop closure
                                        handleDeleteChat();
                                    }}
                                    icon={<DeleteRedIcon />}
                                >
                                    Delete Chat
                                </Button>
                            </div>
                        </div>
                    </Modal>
                )
            }


            <AntdModal
                closeIcon={null}
                footer={null}
                open={isOpenVisualModal?.state}
                centered
                width={isOpenVisualModal?.response?.visual_tag?.toLowerCase() === 'geo' || isOpenVisualModal?.response?.visual_tag?.toLowerCase() === 'geo_map' ? 1200 : 1000}
                bodyStyle={{
                    padding: 0,
                    overflow: 'visible',
                    height: isOpenVisualModal?.response?.visual_tag?.toLowerCase() === 'geo' || isOpenVisualModal?.response?.visual_tag?.toLowerCase() === 'geo_map' ? '70vh' : 'auto',
                    maxHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                onOk={() => {
                    ReactGA.event('visual_collapsed', {
                        chat_id: chatId,
                    });
                    setOpenVisualModal({
                        state: false,
                        type: null
                    });
                }}
                // confirmLoading={confirmLoading}
                onCancel={() => {
                    ReactGA.event('visual_collapsed', {
                        chat_id: chatId,
                    });
                    setOpenVisualModal({
                        state: false,
                        type: null
                    });
                }}
            >
                <Tooltip title="Close" placement='top'>
                    <Button
                        onClick={() => handleVisualModal(null, false, {})}
                        shape="circle"
                        className='bg-gray-100 absolute right-0 z-10 m-1'
                        icon={<CollapseIcon className={"w-3 h-3"} />}
                    />
                </Tooltip>
                <Tooltip title="Download Excel" placement='top'>
                    <Button onClick={() => setExportEnable(false)} shape="circle" className='bg-gray-100 absolute right-[40px] z-10 m-1' icon={<DownloadIcon className={"w-3 h-3"} />} />
                </Tooltip>


                {isOpenVisualModal?.type === 'graph' ? (
                    (() => {
                        const response = isOpenVisualModal?.response;
                        const tag = response?.visual_tag;
                        const data = (() => {
                            // First check if response has a data property
                            if (response?.data) {
                                if (Array.isArray(response.data)) return response.data;
                                // If data has nested data property
                                if (response.data.data) return response.data.data;
                            }
                            // Fallback to chartData or tableData
                            return response?.chartData ?? response?.tableData ?? [];
                        })();

                        // Check if it's a geo map - render directly with CustomGeoMap
                        if (tag?.toLowerCase() === 'geo' || tag?.toLowerCase() === 'geo_map') {
                            // Calculate dynamic height based on viewport
                            const mapHeight = Math.min(Math.max(window.innerHeight * 0.65, 450), 650);

                            return (
                                <div style={{
                                    padding: '20px',
                                    height: `${mapHeight + 40}px`, // Map height plus padding
                                    width: '100%',
                                    position: 'relative',
                                    overflow: 'visible',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <CustomGeoMap
                                        data={data}
                                        height={mapHeight}
                                        showTooltip={true}
                                        className="w-full"
                                    />
                                </div>
                            );
                        }

                        // For other chart types, use CustomChart
                        return (
                            <CustomChart
                                className='p-3 pl-6'
                                data={data}
                                type={(() => {
                                    const typeMap = {
                                        'pie': 'pie-chart',
                                        'pie_chart': 'pie-chart',
                                        'piechart': 'pie-chart',
                                        'donut': 'donut-chart',
                                        'donut_chart': 'donut-chart',
                                        'bar': 'bar-chart',
                                        'bar_chart': 'bar-chart',
                                        'barchart': 'bar-chart',
                                        'multi_bar': 'multi-bar',
                                        'multi_bar_chart': 'multi-bar',
                                        'multibarchart': 'multi-bar',
                                        'multi_bar_chart_secondary_y_axis': 'multi-bar-chart-secondary-y-axis',
                                        'multi-bar-chart-secondary-y-axis': 'multi-bar-chart-secondary-y-axis',
                                        'line_graph_secondary_y_axis': 'line-graph-secondary-y-axis',
                                        'line-graph-secondary-y-axis': 'line-graph-secondary-y-axis',
                                        'bar_graph_secondary_y_axis': 'bar-graph-secondary-y-axis',
                                        'bar-graph-secondary-y-axis': 'bar-graph-secondary-y-axis',
                                        'horizontal_bar_chart': 'horizontal-bar',
                                        'horizontal-bar-chart': 'horizontal-bar',
                                        'horizontalbarchart': 'horizontal-bar',
                                        'multi_horizontal_bar_chart': 'multi-horizontal-bar',
                                        'multi-horizontal-bar-chart': 'multi-horizontal-bar',
                                        'multihorizontalbarchart': 'multi-horizontal-bar',
                                        'line': 'line-graph',
                                        'line_graph': 'line-graph',
                                        'area': 'area-chart',
                                        'area_chart': 'area-chart',
                                        'areachart': 'area-chart',
                                        'scatter': 'scatter-plot',
                                        'scatter_plot': 'scatter-plot',
                                        'table': 'table'
                                    };
                                    return typeMap[tag?.toLowerCase()] || tag || 'bar-chart';
                                })()}
                                size='large'
                                dataXkey={handleTicker(response?.data?.data ?? response?.data, response?.visual_tag)?.xAxis || ''}
                                dataYKey={handleTicker(response?.data, response?.visual_tag)?.yAxis || ''}
                                xAxisLabel={handleTicker(response?.data, response?.visual_tag)?.xLabel || ''}
                                yAxisLabel={handleTicker(response?.data, response?.visual_tag)?.yLabel || ''}
                            />
                        );
                    })()
                ) : (
                    <div className="mt-0 w-full">
                        <div className="bg-white rounded-lg shadow-sm overflow-auto max-h-[calc(90vh-150px)]">
                            <DynamicTable
                                data={(() => {
                                    const response = isOpenVisualModal?.response;
                                    // Check if response has a data property
                                    if (response?.data) {
                                        if (Array.isArray(response.data)) return response.data;
                                        if (response.data.data) return response.data.data;
                                    }
                                    return response?.tableData ?? [];
                                })()}
                                showPagination={true}
                                sortable={true}
                            />
                        </div>
                    </div>
                )}
            </AntdModal>

            <AntdModal
                footer={null}
                open={thumbsAction?.open}
                centered
                className="xl:w-[35%] lg:w-[50%] md:w-[70%] sm:w-[80%]"
            // confirmLoading={confirmLoading}
            >
                <div className="p-5">
                    <h4 className="text-lg font-semibold">{thumbsAction?.method === 'add' ? "Comments" : "Edit Comments"}</h4>
                    <div className="flex flex-col gap-4 mt-5" onClick={(e) => e.stopPropagation()}>
                        {/* <div className='w-full'>
                            <p>FeedBack Type</p>
                            <Select
                                defaultValue="lucy"
                                className='w-full'
                                onChange={(e) => {
                                    setThumbsAction({
                                        ...thumbsAction,
                                        type: e
                                    });
                                }}
                                options={[
                                    { value: 'jack', label: 'Jack' },
                                    { value: 'lucy', label: 'Lucy' },
                                    { value: 'Yiminghe', label: 'yiminghe' },
                                    { value: 'disabled', label: 'Disabled', disabled: true },
                                ]}
                            />
                        </div> */}
                        <TextArea
                            rows={4}
                            placeholder="Enter your comments here..."
                            value={thumbsAction?.comment}
                            onChange={(e) => {
                                setThumbsAction({
                                    ...thumbsAction,
                                    comment: e.target.value
                                });
                            }}
                        />
                        <div className="flex justify-end space-x-2 mt-1">
                            <Button
                                type="default"
                                onClick={(e) => {
                                    setThumbsAction({
                                        open: false,
                                        status: null,
                                        time: null,
                                        method: "add"
                                    })
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                loading={thumbsUpLoading}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleUpdatethumbsUpStatus();
                                }}
                            >
                                Sumbit
                            </Button>
                        </div>
                    </div>
                </div>
            </AntdModal>
        </>
    );
};

export default Conversation;
